import { SortOrder, SortType } from '@fullstory/proto/fs/api/metrics';
import { TimeInterval } from '@fullstory/proto/fs/api/segment';
import { Visibility } from '@fullstory/proto/fs/gcloud/dstore/protoauditstore';
import { RetentionMetricDetail, SegmentDetail } from '@fullstory/proto/fs/services/dx-objects';
import { duration, int64, timestamp } from '@fullstory/proto/google/protobuf';
import { RetentionResultWithId } from '@fullstory/redux/modules/retention/types';
export * from './endpoints';
export * from './responses';
export * from './utils';

export const mockRetentionMetric: RetentionMetricDetail = {
  retentionMetric: {
    retentionMetric: {
      id: 'test',
      name: 'Test Retention',
      description: '',
      retentionMetric: {
        entry: null,
        returns: [],
        constraints: null,
        timeInterval: 2,
        onOrAfter: false,
        multipleEntries: false,
      },
      retentionSettings: {
        segment: [
          {
            segmentId: 'everyone',
            segmentScope: 3,
          },
        ],
        dimensionSettings: {
          dimension: {
            builtInProperty: 10,
            prefix: '',
            limit: 0,
            computeAtLevel: false,
            eventRefinement: null,
          },
          dimensions: [
            {
              builtInProperty: 10,
              prefix: '',
              limit: 0,
              computeAtLevel: false,
              eventRefinement: null,
            },
          ],
          sortOrder: SortOrder.SORT_ORDER_DESC,
          sortByDefault: false,
          sortType: SortType.SORT_TYPE_INVALID,
          limit: 50,
          computeTopLevel: false,
          computeNumGroups: false,
          allowAllPartialResults: false,
          noFallback: false,
        },
        timeRange: {
          startTime: 'NOW/DAY-29DAY',
          endTime: 'NOW/DAY+1DAY',
        },
        timeInterval: 2,
        returnWindow: null,
        timeRangeComparison: null,
      },
    },
    metadata: null,
  },
  starred: false,
  lastViewed: null,
};

export const dimensionResponse: RetentionResultWithId = {
  retentions: [
    {
      cohort: [
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(4256),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(4246),
                int64.fromNumber(885),
                int64.fromNumber(990),
                int64.fromNumber(945),
                int64.fromNumber(873),
                int64.fromNumber(822),
                int64.fromNumber(576),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(4246),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(885),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(990),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(945),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(873),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(822),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(576),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(8263),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(8248),
                int64.fromNumber(1212),
                int64.fromNumber(967),
                int64.fromNumber(846),
                int64.fromNumber(793),
                int64.fromNumber(430),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(8248),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1212),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(967),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(846),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(793),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(430),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(13436),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(13400),
                int64.fromNumber(3997),
                int64.fromNumber(3419),
                int64.fromNumber(3153),
                int64.fromNumber(2315),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(13400),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3997),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3419),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3153),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2315),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(10324),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(10287),
                int64.fromNumber(1916),
                int64.fromNumber(1432),
                int64.fromNumber(915),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(10287),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1916),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1432),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(915),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(9358),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(8573), int64.fromNumber(1353), int64.fromNumber(692)],
              eventCounts: [
                {
                  count: int64.fromNumber(8573),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1353),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(692),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(8194),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(8180), int64.fromNumber(813)],
              eventCounts: [
                {
                  count: int64.fromNumber(8180),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(813),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(4316),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(4273)],
              eventCounts: [
                {
                  count: int64.fromNumber(4273),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [],
      id: '9a98518d-32fb-44d1-baed-f5e0f06f5ff4',
    },
    {
      cohort: [
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(3195),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(3188),
                int64.fromNumber(783),
                int64.fromNumber(886),
                int64.fromNumber(848),
                int64.fromNumber(791),
                int64.fromNumber(743),
                int64.fromNumber(509),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(3188),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(783),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(886),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(848),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(791),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(743),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(509),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(6736),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(6734),
                int64.fromNumber(1063),
                int64.fromNumber(861),
                int64.fromNumber(747),
                int64.fromNumber(716),
                int64.fromNumber(395),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(6734),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1063),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(861),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(747),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(716),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(395),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(11492),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(11465),
                int64.fromNumber(3615),
                int64.fromNumber(3119),
                int64.fromNumber(2880),
                int64.fromNumber(2105),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(11465),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3615),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3119),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2880),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2105),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(8453),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(8429),
                int64.fromNumber(1714),
                int64.fromNumber(1274),
                int64.fromNumber(832),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(8429),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1714),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1274),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(832),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(7616),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(7070), int64.fromNumber(1195), int64.fromNumber(619)],
              eventCounts: [
                {
                  count: int64.fromNumber(7070),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1195),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(619),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(6415),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(6408), int64.fromNumber(713)],
              eventCounts: [
                {
                  count: int64.fromNumber(6408),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(713),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(3515),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(3477)],
              eventCounts: [
                {
                  count: int64.fromNumber(3477),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'Chrome',
          fallback: false,
        },
      ],
      id: '7fc98e75-7b19-4104-9f64-dd44f9c871b8',
    },
    {
      cohort: [
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(690),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(690),
                int64.fromNumber(57),
                int64.fromNumber(45),
                int64.fromNumber(41),
                int64.fromNumber(38),
                int64.fromNumber(35),
                int64.fromNumber(24),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(690),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(57),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(45),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(41),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(940),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(939),
                int64.fromNumber(57),
                int64.fromNumber(39),
                int64.fromNumber(31),
                int64.fromNumber(26),
                int64.fromNumber(14),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(939),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(57),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(39),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(1000),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(996),
                int64.fromNumber(154),
                int64.fromNumber(102),
                int64.fromNumber(84),
                int64.fromNumber(76),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(996),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(154),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(102),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(84),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(76),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(984),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(981),
                int64.fromNumber(89),
                int64.fromNumber(64),
                int64.fromNumber(32),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(981),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(89),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(64),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(1007),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(836), int64.fromNumber(70), int64.fromNumber(35)],
              eventCounts: [
                {
                  count: int64.fromNumber(836),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(70),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(968),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(967), int64.fromNumber(43)],
              eventCounts: [
                {
                  count: int64.fromNumber(967),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(43),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(402),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(399)],
              eventCounts: [
                {
                  count: int64.fromNumber(399),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'Safari',
          fallback: false,
        },
      ],
      id: 'e2daeb23-ecc1-403f-b811-2fcaa688baf6',
    },
    {
      cohort: [
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(113),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(113),
                int64.fromNumber(24),
                int64.fromNumber(27),
                int64.fromNumber(30),
                int64.fromNumber(26),
                int64.fromNumber(23),
                int64.fromNumber(21),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(113),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(184),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(184),
                int64.fromNumber(49),
                int64.fromNumber(32),
                int64.fromNumber(34),
                int64.fromNumber(33),
                int64.fromNumber(12),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(184),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(49),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(520),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(519),
                int64.fromNumber(162),
                int64.fromNumber(146),
                int64.fromNumber(139),
                int64.fromNumber(100),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(519),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(162),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(146),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(139),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(100),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(455),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(454),
                int64.fromNumber(88),
                int64.fromNumber(71),
                int64.fromNumber(39),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(454),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(88),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(71),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(39),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(338),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(316), int64.fromNumber(69), int64.fromNumber(31)],
              eventCounts: [
                {
                  count: int64.fromNumber(316),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(69),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(369),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(368), int64.fromNumber(42)],
              eventCounts: [
                {
                  count: int64.fromNumber(368),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(42),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(197),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(196)],
              eventCounts: [
                {
                  count: int64.fromNumber(196),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'Microsoft Edge',
          fallback: false,
        },
      ],
      id: '03c4a0ca-d7d4-43a4-9cf5-21131596de71',
    },
    {
      cohort: [
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(74),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(74),
                int64.fromNumber(12),
                int64.fromNumber(16),
                int64.fromNumber(10),
                int64.fromNumber(8),
                int64.fromNumber(7),
                int64.fromNumber(6),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(74),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(106),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(106),
                int64.fromNumber(28),
                int64.fromNumber(24),
                int64.fromNumber(20),
                int64.fromNumber(13),
                int64.fromNumber(4),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(106),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(339),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(339),
                int64.fromNumber(87),
                int64.fromNumber(65),
                int64.fromNumber(67),
                int64.fromNumber(41),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(339),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(87),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(65),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(67),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(41),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(284),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(283),
                int64.fromNumber(45),
                int64.fromNumber(36),
                int64.fromNumber(28),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(283),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(45),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(36),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(223),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(207), int64.fromNumber(33), int64.fromNumber(11)],
              eventCounts: [
                {
                  count: int64.fromNumber(207),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(259),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(259), int64.fromNumber(29)],
              eventCounts: [
                {
                  count: int64.fromNumber(259),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(140),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(140)],
              eventCounts: [
                {
                  count: int64.fromNumber(140),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'Firefox',
          fallback: false,
        },
      ],
      id: 'b35c5ccb-e925-49f4-b315-b9285de90a7c',
    },
    {
      cohort: [
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(164),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(164),
                int64.fromNumber(8),
                int64.fromNumber(6),
                int64.fromNumber(6),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(164),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(251),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(251),
                int64.fromNumber(9),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(251),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(188),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(188),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(188),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(214),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(214),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(214),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(210),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(183), int64.fromNumber(2), int64.fromNumber(1)],
              eventCounts: [
                {
                  count: int64.fromNumber(183),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(229),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(229), int64.fromNumber(1)],
              eventCounts: [
                {
                  count: int64.fromNumber(229),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(80),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(80)],
              eventCounts: [
                {
                  count: int64.fromNumber(80),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'Mobile App',
          fallback: false,
        },
      ],
      id: '0e93ea98-404b-4122-b57e-6acb4b935274',
    },
    {
      cohort: [
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(23),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(23),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(28),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(28),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(25),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(25),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(42),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(42),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(42),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(26),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(24), int64.fromNumber(1), int64.fromNumber(1)],
              eventCounts: [
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(32),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(32), int64.fromNumber(0)],
              eventCounts: [
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(17),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(17)],
              eventCounts: [
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'Unknown',
          fallback: false,
        },
      ],
      id: 'ee9e235b-be4e-402c-967d-16eab55b16f6',
    },
    {
      cohort: [
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(18),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(18),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(24),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(24),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(4),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(18),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(18),
                int64.fromNumber(6),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(28),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(28),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(25),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(24), int64.fromNumber(3), int64.fromNumber(1)],
              eventCounts: [
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(26),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(26), int64.fromNumber(1)],
              eventCounts: [
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(15),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(15)],
              eventCounts: [
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'Opera',
          fallback: false,
        },
      ],
      id: '4edb1a49-bbf7-481d-8e67-c9dc8e919abf',
    },
    {
      cohort: [
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(2),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(6),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(6),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(2),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(5),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(5), int64.fromNumber(0), int64.fromNumber(0)],
              eventCounts: [
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(3),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(3), int64.fromNumber(1)],
              eventCounts: [
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(1),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(1)],
              eventCounts: [
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'Robot',
          fallback: false,
        },
      ],
      id: '167721a7-4651-4236-9ca3-644087cc7a68',
    },
    {
      cohort: [
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(1),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(4),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(4),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(1),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(4),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(4),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(4), int64.fromNumber(1), int64.fromNumber(0)],
              eventCounts: [
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(0), int64.fromNumber(0)],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(2),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(2)],
              eventCounts: [
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'Yandex',
          fallback: false,
        },
      ],
      id: 'a0ee2824-96b2-4b6f-a2ad-e7f43ff39462',
    },
    {
      cohort: [
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(1),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(1),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(1),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(1), int64.fromNumber(0), int64.fromNumber(0)],
              eventCounts: [
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(1),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(1), int64.fromNumber(0)],
              eventCounts: [
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(1),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(1)],
              eventCounts: [
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'Internet Explorer',
          fallback: false,
        },
      ],
      id: 'b4af649e-f137-4d90-a017-53a1b5d02a70',
    },
  ],
  numGroups: int64.fromNumber(10),
};

export const newThisWeekSegmentResponse: RetentionResultWithId = {
  retentions: [
    {
      cohort: [
        {
          entryStart: '2022-11-15T08:00:00Z' as timestamp,
          entryEnd: '2022-11-16T08:00:00Z' as timestamp,
          count: int64.fromNumber(5758),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(5758),
                int64.fromNumber(377),
                int64.fromNumber(221),
                int64.fromNumber(138),
                int64.fromNumber(57),
                int64.fromNumber(71),
                int64.fromNumber(114),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(5758),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(377),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(221),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(138),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(57),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(71),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(114),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-11-16T08:00:00Z' as timestamp,
          entryEnd: '2022-11-17T08:00:00Z' as timestamp,
          count: int64.fromNumber(5662),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(5662),
                int64.fromNumber(410),
                int64.fromNumber(190),
                int64.fromNumber(82),
                int64.fromNumber(101),
                int64.fromNumber(140),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(5662),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(410),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(190),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(82),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(101),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(140),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-11-17T08:00:00Z' as timestamp,
          entryEnd: '2022-11-18T08:00:00Z' as timestamp,
          count: int64.fromNumber(5885),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(5885),
                int64.fromNumber(362),
                int64.fromNumber(105),
                int64.fromNumber(125),
                int64.fromNumber(150),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(5885),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(362),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(105),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(125),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(150),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-11-18T08:00:00Z' as timestamp,
          entryEnd: '2022-11-19T08:00:00Z' as timestamp,
          count: int64.fromNumber(19052),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(19051),
                int64.fromNumber(157),
                int64.fromNumber(116),
                int64.fromNumber(177),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(19051),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(157),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(116),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(177),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-11-19T08:00:00Z' as timestamp,
          entryEnd: '2022-11-20T08:00:00Z' as timestamp,
          count: int64.fromNumber(2852),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(2852), int64.fromNumber(108), int64.fromNumber(59)],
              eventCounts: [
                {
                  count: int64.fromNumber(2852),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(108),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(59),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-11-20T08:00:00Z' as timestamp,
          entryEnd: '2022-11-21T08:00:00Z' as timestamp,
          count: int64.fromNumber(6473),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(6473), int64.fromNumber(200)],
              eventCounts: [
                {
                  count: int64.fromNumber(6473),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(200),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-11-21T08:00:00Z' as timestamp,
          entryEnd: '2022-11-22T08:00:00Z' as timestamp,
          count: int64.fromNumber(4177),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(4160)],
              eventCounts: [
                {
                  count: int64.fromNumber(4160),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [],
      id: 'f6bd2d65-65ff-4db2-99cb-3404eb4e5009',
    },
  ],
  numGroups: int64.fromNumber(0),
};

export const mobileSegmentResponse: RetentionResultWithId = {
  retentions: [
    {
      cohort: [
        {
          entryStart: '2022-11-15T08:00:00Z' as timestamp,
          entryEnd: '2022-11-16T08:00:00Z' as timestamp,
          count: int64.fromNumber(1467),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1465),
                int64.fromNumber(188),
                int64.fromNumber(142),
                int64.fromNumber(116),
                int64.fromNumber(66),
                int64.fromNumber(80),
                int64.fromNumber(118),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1465),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(188),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(142),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(116),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(66),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(80),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(118),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-11-16T08:00:00Z' as timestamp,
          entryEnd: '2022-11-17T08:00:00Z' as timestamp,
          count: int64.fromNumber(1116),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1116),
                int64.fromNumber(65),
                int64.fromNumber(24),
                int64.fromNumber(17),
                int64.fromNumber(17),
                int64.fromNumber(22),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1116),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(65),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-11-17T08:00:00Z' as timestamp,
          entryEnd: '2022-11-18T08:00:00Z' as timestamp,
          count: int64.fromNumber(1215),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1215),
                int64.fromNumber(54),
                int64.fromNumber(18),
                int64.fromNumber(14),
                int64.fromNumber(16),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1215),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(54),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-11-18T08:00:00Z' as timestamp,
          entryEnd: '2022-11-19T08:00:00Z' as timestamp,
          count: int64.fromNumber(975),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(975),
                int64.fromNumber(29),
                int64.fromNumber(14),
                int64.fromNumber(17),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(975),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-11-19T08:00:00Z' as timestamp,
          entryEnd: '2022-11-20T08:00:00Z' as timestamp,
          count: int64.fromNumber(887),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(887), int64.fromNumber(19), int64.fromNumber(6)],
              eventCounts: [
                {
                  count: int64.fromNumber(887),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-11-20T08:00:00Z' as timestamp,
          entryEnd: '2022-11-21T08:00:00Z' as timestamp,
          count: int64.fromNumber(1081),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(1081), int64.fromNumber(37)],
              eventCounts: [
                {
                  count: int64.fromNumber(1081),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-11-21T08:00:00Z' as timestamp,
          entryEnd: '2022-11-22T08:00:00Z' as timestamp,
          count: int64.fromNumber(716),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(711)],
              eventCounts: [
                {
                  count: int64.fromNumber(711),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [],
      id: 'e01f6cd6-cee1-4ba6-aca3-681fcefce3d5',
    },
  ],
  numGroups: int64.fromNumber(0),
};

export const rageClickSegmentResponse: RetentionResultWithId = {
  retentions: [
    {
      cohort: [
        {
          entryStart: '2022-11-15T08:00:00Z' as timestamp,
          entryEnd: '2022-11-16T08:00:00Z' as timestamp,
          count: int64.fromNumber(161),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(161),
                int64.fromNumber(117),
                int64.fromNumber(110),
                int64.fromNumber(92),
                int64.fromNumber(22),
                int64.fromNumber(41),
                int64.fromNumber(86),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(161),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(117),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(110),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(92),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(41),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(86),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-11-16T08:00:00Z' as timestamp,
          entryEnd: '2022-11-17T08:00:00Z' as timestamp,
          count: int64.fromNumber(47),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(47),
                int64.fromNumber(22),
                int64.fromNumber(17),
                int64.fromNumber(7),
                int64.fromNumber(7),
                int64.fromNumber(18),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(47),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-11-17T08:00:00Z' as timestamp,
          entryEnd: '2022-11-18T08:00:00Z' as timestamp,
          count: int64.fromNumber(30),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(30),
                int64.fromNumber(15),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(11),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-11-18T08:00:00Z' as timestamp,
          entryEnd: '2022-11-19T08:00:00Z' as timestamp,
          count: int64.fromNumber(24),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(24),
                int64.fromNumber(4),
                int64.fromNumber(6),
                int64.fromNumber(8),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-11-19T08:00:00Z' as timestamp,
          entryEnd: '2022-11-20T08:00:00Z' as timestamp,
          count: int64.fromNumber(7),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(7), int64.fromNumber(3), int64.fromNumber(4)],
              eventCounts: [
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-11-20T08:00:00Z' as timestamp,
          entryEnd: '2022-11-21T08:00:00Z' as timestamp,
          count: int64.fromNumber(5),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(5), int64.fromNumber(0)],
              eventCounts: [
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-11-21T08:00:00Z' as timestamp,
          entryEnd: '2022-11-22T08:00:00Z' as timestamp,
          count: int64.fromNumber(15),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(15)],
              eventCounts: [
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [],
      id: 'd1a68889-705e-4232-8d4e-f4e1206459ad',
    },
  ],
  numGroups: int64.fromNumber(0),
};

export const newThisWeekSegment: SegmentDetail = {
  segment: {
    segment: {
      id: 'newThisWeek',
      name: 'New this week',
      description: '',
      segmentDefinition: {
        userProperties: [
          {
            primary: {
              firstSeen: {
                range: {
                  value: {
                    startTime: 'NOW/DAY-6DAY',
                    endTime: 'NOW/DAY+1DAY',
                  },
                },
              },
            },
          },
        ],
        excludeUserProperties: [],
        behaviors: [],
        excludeBehaviors: [],
        constraints: {
          inOrder: false,
          inSameSession: false,
          platform: 0,
          timeRange: {
            startTime: 'NOW/DAY-6DAY',
            endTime: 'NOW/DAY+1DAY',
          },
          completeSessions: false,
          withinTime: '0s' as duration,
          eventThresholds: [],
        },
        excludeConstraints: null,
      },
    },
    segmentMetadata: {
      canned: true,
    },
    metadata: {
      lastUpdated: null,
      lastUpdatedBy: 'system',
      created: null,
      createdBy: 'system',
      archived: false,
      visibility: Visibility.PUBLIC,
      version: int64.fromNumber(0),
      sequentialVersion: int64.fromNumber(0),
    },
  },
  starred: true,
  lastViewed: '2022-09-07T22:58:57.780Z' as timestamp,
};

export const mobileSegment: SegmentDetail = {
  segment: {
    segment: {
      id: 'mobileUsers',
      name: 'Mobile',
      description: '',
      segmentDefinition: {
        userProperties: [],
        excludeUserProperties: [],
        behaviors: [
          {
            event: {
              primary: null,
              deps: [
                {
                  device: {
                    equals: {
                      value: [3],
                    },
                  },
                },
              ],
            },
          },
        ],
        excludeBehaviors: [],
        constraints: {
          inOrder: false,
          inSameSession: false,
          platform: 0,
          timeRange: {
            startTime: 'NOW/DAY-29DAY',
            endTime: 'NOW/DAY+1DAY',
          },
          completeSessions: false,
          withinTime: '0s' as duration,
          eventThresholds: [],
        },
        excludeConstraints: null,
      },
    },
    segmentMetadata: {
      canned: true,
    },
    metadata: {
      lastUpdated: null,
      lastUpdatedBy: 'system',
      created: null,
      createdBy: 'system',
      archived: false,
      visibility: Visibility.PUBLIC,
      version: int64.fromNumber(0),
      sequentialVersion: int64.fromNumber(0),
    },
  },
  starred: true,
  lastViewed: '2022-06-28T18:16:30.586Z' as timestamp,
};

export const complexResponse: RetentionResultWithId = {
  retentions: [
    {
      cohort: [
        {
          entryStart: '2022-05-29T07:00:00Z' as timestamp,
          entryEnd: '2022-05-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-30T07:00:00Z' as timestamp,
          entryEnd: '2022-05-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-31T07:00:00Z' as timestamp,
          entryEnd: '2022-06-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-01T07:00:00Z' as timestamp,
          entryEnd: '2022-06-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-02T07:00:00Z' as timestamp,
          entryEnd: '2022-06-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-03T07:00:00Z' as timestamp,
          entryEnd: '2022-06-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-04T07:00:00Z' as timestamp,
          entryEnd: '2022-06-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-05T07:00:00Z' as timestamp,
          entryEnd: '2022-06-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-06T07:00:00Z' as timestamp,
          entryEnd: '2022-06-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-07T07:00:00Z' as timestamp,
          entryEnd: '2022-06-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-08T07:00:00Z' as timestamp,
          entryEnd: '2022-06-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-09T07:00:00Z' as timestamp,
          entryEnd: '2022-06-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-10T07:00:00Z' as timestamp,
          entryEnd: '2022-06-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-11T07:00:00Z' as timestamp,
          entryEnd: '2022-06-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-12T07:00:00Z' as timestamp,
          entryEnd: '2022-06-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-13T07:00:00Z' as timestamp,
          entryEnd: '2022-06-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-14T07:00:00Z' as timestamp,
          entryEnd: '2022-06-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-15T07:00:00Z' as timestamp,
          entryEnd: '2022-06-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-16T07:00:00Z' as timestamp,
          entryEnd: '2022-06-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-17T07:00:00Z' as timestamp,
          entryEnd: '2022-06-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-18T07:00:00Z' as timestamp,
          entryEnd: '2022-06-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-19T07:00:00Z' as timestamp,
          entryEnd: '2022-06-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-20T07:00:00Z' as timestamp,
          entryEnd: '2022-06-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-21T07:00:00Z' as timestamp,
          entryEnd: '2022-06-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-22T07:00:00Z' as timestamp,
          entryEnd: '2022-06-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-23T07:00:00Z' as timestamp,
          entryEnd: '2022-06-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-24T07:00:00Z' as timestamp,
          entryEnd: '2022-06-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-25T07:00:00Z' as timestamp,
          entryEnd: '2022-06-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-26T07:00:00Z' as timestamp,
          entryEnd: '2022-06-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-27T07:00:00Z' as timestamp,
          entryEnd: '2022-06-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-28T07:00:00Z' as timestamp,
          entryEnd: '2022-06-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-29T07:00:00Z' as timestamp,
          entryEnd: '2022-06-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-01T07:00:00Z' as timestamp,
          entryEnd: '2022-07-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-02T07:00:00Z' as timestamp,
          entryEnd: '2022-07-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-03T07:00:00Z' as timestamp,
          entryEnd: '2022-07-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-04T07:00:00Z' as timestamp,
          entryEnd: '2022-07-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-05T07:00:00Z' as timestamp,
          entryEnd: '2022-07-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-06T07:00:00Z' as timestamp,
          entryEnd: '2022-07-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-07T07:00:00Z' as timestamp,
          entryEnd: '2022-07-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-08T07:00:00Z' as timestamp,
          entryEnd: '2022-07-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-09T07:00:00Z' as timestamp,
          entryEnd: '2022-07-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-10T07:00:00Z' as timestamp,
          entryEnd: '2022-07-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-11T07:00:00Z' as timestamp,
          entryEnd: '2022-07-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-12T07:00:00Z' as timestamp,
          entryEnd: '2022-07-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-13T07:00:00Z' as timestamp,
          entryEnd: '2022-07-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-14T07:00:00Z' as timestamp,
          entryEnd: '2022-07-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-15T07:00:00Z' as timestamp,
          entryEnd: '2022-07-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-16T07:00:00Z' as timestamp,
          entryEnd: '2022-07-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-17T07:00:00Z' as timestamp,
          entryEnd: '2022-07-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-18T07:00:00Z' as timestamp,
          entryEnd: '2022-07-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-19T07:00:00Z' as timestamp,
          entryEnd: '2022-07-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-20T07:00:00Z' as timestamp,
          entryEnd: '2022-07-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-21T07:00:00Z' as timestamp,
          entryEnd: '2022-07-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-22T07:00:00Z' as timestamp,
          entryEnd: '2022-07-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-23T07:00:00Z' as timestamp,
          entryEnd: '2022-07-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-24T07:00:00Z' as timestamp,
          entryEnd: '2022-07-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-25T07:00:00Z' as timestamp,
          entryEnd: '2022-07-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-26T07:00:00Z' as timestamp,
          entryEnd: '2022-07-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-27T07:00:00Z' as timestamp,
          entryEnd: '2022-07-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(295),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(282),
                int64.fromNumber(270),
                int64.fromNumber(173),
                int64.fromNumber(129),
                int64.fromNumber(168),
                int64.fromNumber(166),
                int64.fromNumber(155),
                int64.fromNumber(140),
                int64.fromNumber(128),
                int64.fromNumber(93),
                int64.fromNumber(57),
                int64.fromNumber(85),
                int64.fromNumber(100),
                int64.fromNumber(91),
                int64.fromNumber(87),
                int64.fromNumber(81),
                int64.fromNumber(46),
                int64.fromNumber(33),
                int64.fromNumber(50),
                int64.fromNumber(69),
                int64.fromNumber(72),
                int64.fromNumber(67),
                int64.fromNumber(60),
                int64.fromNumber(33),
                int64.fromNumber(26),
                int64.fromNumber(39),
                int64.fromNumber(56),
                int64.fromNumber(58),
                int64.fromNumber(55),
                int64.fromNumber(54),
                int64.fromNumber(37),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(282),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(270),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(173),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(129),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(168),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(166),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(155),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(140),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(128),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(93),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(57),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(85),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(100),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(91),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(87),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(81),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(50),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(69),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(72),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(67),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(60),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(39),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(56),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(58),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(55),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(54),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-28T07:00:00Z' as timestamp,
          entryEnd: '2022-07-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(9160),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(8216),
                int64.fromNumber(3006),
                int64.fromNumber(576),
                int64.fromNumber(927),
                int64.fromNumber(3076),
                int64.fromNumber(3069),
                int64.fromNumber(3005),
                int64.fromNumber(2864),
                int64.fromNumber(2156),
                int64.fromNumber(401),
                int64.fromNumber(703),
                int64.fromNumber(2749),
                int64.fromNumber(2652),
                int64.fromNumber(2611),
                int64.fromNumber(2473),
                int64.fromNumber(1968),
                int64.fromNumber(314),
                int64.fromNumber(525),
                int64.fromNumber(2441),
                int64.fromNumber(2451),
                int64.fromNumber(2512),
                int64.fromNumber(2402),
                int64.fromNumber(1944),
                int64.fromNumber(321),
                int64.fromNumber(549),
                int64.fromNumber(2417),
                int64.fromNumber(2382),
                int64.fromNumber(2259),
                int64.fromNumber(2369),
                int64.fromNumber(1685),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(8216),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3006),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(576),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(927),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3076),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3069),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3005),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2864),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2156),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(401),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(703),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2749),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2652),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2611),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2473),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1968),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(314),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(525),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2441),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2451),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2512),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2402),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1944),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(321),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(549),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2417),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2382),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2259),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2369),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1685),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-29T07:00:00Z' as timestamp,
          entryEnd: '2022-07-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(4126),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(3500),
                int64.fromNumber(163),
                int64.fromNumber(212),
                int64.fromNumber(906),
                int64.fromNumber(818),
                int64.fromNumber(782),
                int64.fromNumber(744),
                int64.fromNumber(683),
                int64.fromNumber(101),
                int64.fromNumber(127),
                int64.fromNumber(724),
                int64.fromNumber(692),
                int64.fromNumber(706),
                int64.fromNumber(616),
                int64.fromNumber(554),
                int64.fromNumber(76),
                int64.fromNumber(81),
                int64.fromNumber(629),
                int64.fromNumber(666),
                int64.fromNumber(641),
                int64.fromNumber(593),
                int64.fromNumber(555),
                int64.fromNumber(67),
                int64.fromNumber(92),
                int64.fromNumber(597),
                int64.fromNumber(615),
                int64.fromNumber(534),
                int64.fromNumber(595),
                int64.fromNumber(462),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(3500),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(163),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(212),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(906),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(818),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(782),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(744),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(683),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(101),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(127),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(724),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(692),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(706),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(616),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(554),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(76),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(81),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(629),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(666),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(641),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(593),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(555),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(67),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(92),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(597),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(615),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(534),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(595),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(462),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(655),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(456),
                int64.fromNumber(95),
                int64.fromNumber(99),
                int64.fromNumber(93),
                int64.fromNumber(87),
                int64.fromNumber(83),
                int64.fromNumber(53),
                int64.fromNumber(57),
                int64.fromNumber(54),
                int64.fromNumber(73),
                int64.fromNumber(60),
                int64.fromNumber(58),
                int64.fromNumber(55),
                int64.fromNumber(39),
                int64.fromNumber(31),
                int64.fromNumber(38),
                int64.fromNumber(54),
                int64.fromNumber(48),
                int64.fromNumber(57),
                int64.fromNumber(47),
                int64.fromNumber(40),
                int64.fromNumber(32),
                int64.fromNumber(40),
                int64.fromNumber(57),
                int64.fromNumber(51),
                int64.fromNumber(38),
                int64.fromNumber(41),
                int64.fromNumber(26),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(456),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(95),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(99),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(93),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(87),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(83),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(53),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(57),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(54),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(73),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(60),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(58),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(55),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(39),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(54),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(48),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(57),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(47),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(40),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(40),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(57),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(51),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(41),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-31T07:00:00Z' as timestamp,
          entryEnd: '2022-08-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(1578),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1241),
                int64.fromNumber(328),
                int64.fromNumber(266),
                int64.fromNumber(247),
                int64.fromNumber(223),
                int64.fromNumber(106),
                int64.fromNumber(56),
                int64.fromNumber(183),
                int64.fromNumber(227),
                int64.fromNumber(206),
                int64.fromNumber(174),
                int64.fromNumber(171),
                int64.fromNumber(88),
                int64.fromNumber(43),
                int64.fromNumber(145),
                int64.fromNumber(179),
                int64.fromNumber(168),
                int64.fromNumber(159),
                int64.fromNumber(154),
                int64.fromNumber(65),
                int64.fromNumber(32),
                int64.fromNumber(127),
                int64.fromNumber(153),
                int64.fromNumber(160),
                int64.fromNumber(165),
                int64.fromNumber(154),
                int64.fromNumber(51),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1241),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(328),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(266),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(247),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(223),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(106),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(56),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(183),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(227),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(206),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(174),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(171),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(88),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(43),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(145),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(179),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(168),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(159),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(154),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(65),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(127),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(153),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(160),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(165),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(154),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(51),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-01T07:00:00Z' as timestamp,
          entryEnd: '2022-08-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(5150),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(4349),
                int64.fromNumber(1143),
                int64.fromNumber(909),
                int64.fromNumber(862),
                int64.fromNumber(609),
                int64.fromNumber(73),
                int64.fromNumber(176),
                int64.fromNumber(815),
                int64.fromNumber(772),
                int64.fromNumber(709),
                int64.fromNumber(681),
                int64.fromNumber(498),
                int64.fromNumber(63),
                int64.fromNumber(139),
                int64.fromNumber(667),
                int64.fromNumber(701),
                int64.fromNumber(649),
                int64.fromNumber(631),
                int64.fromNumber(481),
                int64.fromNumber(51),
                int64.fromNumber(119),
                int64.fromNumber(715),
                int64.fromNumber(629),
                int64.fromNumber(614),
                int64.fromNumber(623),
                int64.fromNumber(431),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(4349),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1143),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(909),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(862),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(609),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(73),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(176),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(815),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(772),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(709),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(681),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(498),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(63),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(139),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(667),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(701),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(649),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(631),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(481),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(51),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(119),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(715),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(629),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(614),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(623),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(431),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-02T07:00:00Z' as timestamp,
          entryEnd: '2022-08-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(4555),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(3755),
                int64.fromNumber(856),
                int64.fromNumber(693),
                int64.fromNumber(483),
                int64.fromNumber(71),
                int64.fromNumber(148),
                int64.fromNumber(606),
                int64.fromNumber(586),
                int64.fromNumber(500),
                int64.fromNumber(490),
                int64.fromNumber(348),
                int64.fromNumber(63),
                int64.fromNumber(89),
                int64.fromNumber(430),
                int64.fromNumber(484),
                int64.fromNumber(426),
                int64.fromNumber(410),
                int64.fromNumber(298),
                int64.fromNumber(26),
                int64.fromNumber(78),
                int64.fromNumber(445),
                int64.fromNumber(452),
                int64.fromNumber(421),
                int64.fromNumber(418),
                int64.fromNumber(301),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(3755),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(856),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(693),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(483),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(71),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(148),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(606),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(586),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(500),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(490),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(348),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(63),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(89),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(430),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(484),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(426),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(410),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(298),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(78),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(445),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(452),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(421),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(418),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(301),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-03T07:00:00Z' as timestamp,
          entryEnd: '2022-08-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(4121),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(3324),
                int64.fromNumber(624),
                int64.fromNumber(403),
                int64.fromNumber(72),
                int64.fromNumber(139),
                int64.fromNumber(454),
                int64.fromNumber(434),
                int64.fromNumber(419),
                int64.fromNumber(375),
                int64.fromNumber(265),
                int64.fromNumber(44),
                int64.fromNumber(87),
                int64.fromNumber(344),
                int64.fromNumber(341),
                int64.fromNumber(355),
                int64.fromNumber(327),
                int64.fromNumber(258),
                int64.fromNumber(23),
                int64.fromNumber(55),
                int64.fromNumber(336),
                int64.fromNumber(338),
                int64.fromNumber(324),
                int64.fromNumber(329),
                int64.fromNumber(224),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(3324),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(624),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(403),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(72),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(139),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(454),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(434),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(419),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(375),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(265),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(44),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(87),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(344),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(341),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(355),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(327),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(258),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(55),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(336),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(338),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(324),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(329),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(224),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-04T07:00:00Z' as timestamp,
          entryEnd: '2022-08-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(3760),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2944),
                int64.fromNumber(443),
                int64.fromNumber(69),
                int64.fromNumber(114),
                int64.fromNumber(371),
                int64.fromNumber(350),
                int64.fromNumber(311),
                int64.fromNumber(283),
                int64.fromNumber(203),
                int64.fromNumber(46),
                int64.fromNumber(64),
                int64.fromNumber(264),
                int64.fromNumber(265),
                int64.fromNumber(260),
                int64.fromNumber(291),
                int64.fromNumber(175),
                int64.fromNumber(26),
                int64.fromNumber(48),
                int64.fromNumber(271),
                int64.fromNumber(235),
                int64.fromNumber(237),
                int64.fromNumber(251),
                int64.fromNumber(174),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2944),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(443),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(69),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(114),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(371),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(350),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(311),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(283),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(203),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(64),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(264),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(265),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(260),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(291),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(175),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(48),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(271),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(235),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(237),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(251),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(174),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-05T07:00:00Z' as timestamp,
          entryEnd: '2022-08-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(2562),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2004),
                int64.fromNumber(93),
                int64.fromNumber(87),
                int64.fromNumber(298),
                int64.fromNumber(234),
                int64.fromNumber(225),
                int64.fromNumber(211),
                int64.fromNumber(156),
                int64.fromNumber(36),
                int64.fromNumber(36),
                int64.fromNumber(190),
                int64.fromNumber(181),
                int64.fromNumber(176),
                int64.fromNumber(159),
                int64.fromNumber(159),
                int64.fromNumber(22),
                int64.fromNumber(19),
                int64.fromNumber(159),
                int64.fromNumber(165),
                int64.fromNumber(146),
                int64.fromNumber(128),
                int64.fromNumber(94),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2004),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(93),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(87),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(298),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(234),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(225),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(211),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(156),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(36),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(36),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(190),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(181),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(176),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(159),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(159),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(159),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(165),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(146),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(128),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(94),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-06T07:00:00Z' as timestamp,
          entryEnd: '2022-08-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(808),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(531),
                int64.fromNumber(69),
                int64.fromNumber(58),
                int64.fromNumber(58),
                int64.fromNumber(40),
                int64.fromNumber(46),
                int64.fromNumber(37),
                int64.fromNumber(24),
                int64.fromNumber(25),
                int64.fromNumber(27),
                int64.fromNumber(26),
                int64.fromNumber(30),
                int64.fromNumber(31),
                int64.fromNumber(24),
                int64.fromNumber(18),
                int64.fromNumber(11),
                int64.fromNumber(14),
                int64.fromNumber(18),
                int64.fromNumber(8),
                int64.fromNumber(9),
                int64.fromNumber(5),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(531),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(69),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(58),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(58),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(40),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-07T07:00:00Z' as timestamp,
          entryEnd: '2022-08-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(1096),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(803),
                int64.fromNumber(171),
                int64.fromNumber(113),
                int64.fromNumber(102),
                int64.fromNumber(99),
                int64.fromNumber(57),
                int64.fromNumber(30),
                int64.fromNumber(72),
                int64.fromNumber(86),
                int64.fromNumber(70),
                int64.fromNumber(63),
                int64.fromNumber(68),
                int64.fromNumber(31),
                int64.fromNumber(17),
                int64.fromNumber(39),
                int64.fromNumber(59),
                int64.fromNumber(47),
                int64.fromNumber(43),
                int64.fromNumber(44),
                int64.fromNumber(17),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(803),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(171),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(113),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(102),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(99),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(57),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(72),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(86),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(70),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(63),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(68),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(39),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(59),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(47),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(43),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(44),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-08T07:00:00Z' as timestamp,
          entryEnd: '2022-08-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(3621),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2820),
                int64.fromNumber(519),
                int64.fromNumber(379),
                int64.fromNumber(357),
                int64.fromNumber(264),
                int64.fromNumber(59),
                int64.fromNumber(86),
                int64.fromNumber(316),
                int64.fromNumber(296),
                int64.fromNumber(290),
                int64.fromNumber(294),
                int64.fromNumber(192),
                int64.fromNumber(45),
                int64.fromNumber(75),
                int64.fromNumber(264),
                int64.fromNumber(254),
                int64.fromNumber(216),
                int64.fromNumber(248),
                int64.fromNumber(161),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2820),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(519),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(379),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(357),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(264),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(59),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(86),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(316),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(296),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(290),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(294),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(192),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(45),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(75),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(264),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(254),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(216),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(248),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(161),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-09T07:00:00Z' as timestamp,
          entryEnd: '2022-08-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(3300),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2548),
                int64.fromNumber(425),
                int64.fromNumber(303),
                int64.fromNumber(201),
                int64.fromNumber(48),
                int64.fromNumber(70),
                int64.fromNumber(226),
                int64.fromNumber(239),
                int64.fromNumber(232),
                int64.fromNumber(192),
                int64.fromNumber(161),
                int64.fromNumber(32),
                int64.fromNumber(61),
                int64.fromNumber(209),
                int64.fromNumber(211),
                int64.fromNumber(173),
                int64.fromNumber(183),
                int64.fromNumber(129),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2548),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(425),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(303),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(201),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(48),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(70),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(226),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(239),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(232),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(192),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(161),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(61),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(209),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(211),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(173),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(183),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(129),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-10T07:00:00Z' as timestamp,
          entryEnd: '2022-08-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(3334),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2600),
                int64.fromNumber(395),
                int64.fromNumber(222),
                int64.fromNumber(49),
                int64.fromNumber(77),
                int64.fromNumber(218),
                int64.fromNumber(247),
                int64.fromNumber(215),
                int64.fromNumber(196),
                int64.fromNumber(132),
                int64.fromNumber(27),
                int64.fromNumber(40),
                int64.fromNumber(177),
                int64.fromNumber(196),
                int64.fromNumber(169),
                int64.fromNumber(161),
                int64.fromNumber(100),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2600),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(395),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(222),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(49),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(77),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(218),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(247),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(215),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(196),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(132),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(40),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(177),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(196),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(169),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(161),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(100),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-11T07:00:00Z' as timestamp,
          entryEnd: '2022-08-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(2719),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2122),
                int64.fromNumber(265),
                int64.fromNumber(44),
                int64.fromNumber(65),
                int64.fromNumber(200),
                int64.fromNumber(217),
                int64.fromNumber(156),
                int64.fromNumber(147),
                int64.fromNumber(126),
                int64.fromNumber(29),
                int64.fromNumber(42),
                int64.fromNumber(135),
                int64.fromNumber(159),
                int64.fromNumber(138),
                int64.fromNumber(134),
                int64.fromNumber(73),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2122),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(265),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(44),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(65),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(200),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(217),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(156),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(147),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(126),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(42),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(135),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(159),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(138),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(134),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(73),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-12T07:00:00Z' as timestamp,
          entryEnd: '2022-08-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(2126),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1615),
                int64.fromNumber(76),
                int64.fromNumber(52),
                int64.fromNumber(197),
                int64.fromNumber(157),
                int64.fromNumber(135),
                int64.fromNumber(132),
                int64.fromNumber(109),
                int64.fromNumber(20),
                int64.fromNumber(29),
                int64.fromNumber(106),
                int64.fromNumber(101),
                int64.fromNumber(87),
                int64.fromNumber(98),
                int64.fromNumber(67),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1615),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(76),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(52),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(197),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(157),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(135),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(132),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(109),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(106),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(101),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(87),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(98),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(67),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-13T07:00:00Z' as timestamp,
          entryEnd: '2022-08-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(552),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(347),
                int64.fromNumber(35),
                int64.fromNumber(36),
                int64.fromNumber(31),
                int64.fromNumber(31),
                int64.fromNumber(21),
                int64.fromNumber(24),
                int64.fromNumber(18),
                int64.fromNumber(16),
                int64.fromNumber(18),
                int64.fromNumber(23),
                int64.fromNumber(23),
                int64.fromNumber(20),
                int64.fromNumber(15),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(347),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(36),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-14T07:00:00Z' as timestamp,
          entryEnd: '2022-08-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(1018),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(738),
                int64.fromNumber(104),
                int64.fromNumber(77),
                int64.fromNumber(56),
                int64.fromNumber(46),
                int64.fromNumber(24),
                int64.fromNumber(22),
                int64.fromNumber(43),
                int64.fromNumber(52),
                int64.fromNumber(44),
                int64.fromNumber(46),
                int64.fromNumber(46),
                int64.fromNumber(24),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(738),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(104),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(77),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(56),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(43),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(52),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(44),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-15T07:00:00Z' as timestamp,
          entryEnd: '2022-08-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(2794),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2224),
                int64.fromNumber(366),
                int64.fromNumber(263),
                int64.fromNumber(216),
                int64.fromNumber(153),
                int64.fromNumber(37),
                int64.fromNumber(53),
                int64.fromNumber(198),
                int64.fromNumber(179),
                int64.fromNumber(148),
                int64.fromNumber(169),
                int64.fromNumber(98),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2224),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(366),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(263),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(216),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(153),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(53),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(198),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(179),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(148),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(169),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(98),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-16T07:00:00Z' as timestamp,
          entryEnd: '2022-08-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(2931),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2243),
                int64.fromNumber(342),
                int64.fromNumber(244),
                int64.fromNumber(164),
                int64.fromNumber(37),
                int64.fromNumber(57),
                int64.fromNumber(193),
                int64.fromNumber(198),
                int64.fromNumber(166),
                int64.fromNumber(164),
                int64.fromNumber(103),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2243),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(342),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(244),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(164),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(57),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(193),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(198),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(166),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(164),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(103),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-17T07:00:00Z' as timestamp,
          entryEnd: '2022-08-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(2795),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2151),
                int64.fromNumber(296),
                int64.fromNumber(174),
                int64.fromNumber(52),
                int64.fromNumber(73),
                int64.fromNumber(176),
                int64.fromNumber(155),
                int64.fromNumber(130),
                int64.fromNumber(137),
                int64.fromNumber(95),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2151),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(296),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(174),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(52),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(73),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(176),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(155),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(130),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(137),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(95),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-18T07:00:00Z' as timestamp,
          entryEnd: '2022-08-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(2622),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1975),
                int64.fromNumber(219),
                int64.fromNumber(62),
                int64.fromNumber(72),
                int64.fromNumber(168),
                int64.fromNumber(138),
                int64.fromNumber(132),
                int64.fromNumber(139),
                int64.fromNumber(89),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1975),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(219),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(62),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(72),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(168),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(138),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(132),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(139),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(89),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-19T07:00:00Z' as timestamp,
          entryEnd: '2022-08-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(1793),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1358),
                int64.fromNumber(56),
                int64.fromNumber(42),
                int64.fromNumber(143),
                int64.fromNumber(120),
                int64.fromNumber(101),
                int64.fromNumber(100),
                int64.fromNumber(56),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1358),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(56),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(42),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(143),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(120),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(101),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(100),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(56),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(554),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(372),
                int64.fromNumber(48),
                int64.fromNumber(41),
                int64.fromNumber(35),
                int64.fromNumber(29),
                int64.fromNumber(21),
                int64.fromNumber(17),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(372),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(48),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(41),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(963),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(658),
                int64.fromNumber(78),
                int64.fromNumber(56),
                int64.fromNumber(52),
                int64.fromNumber(42),
                int64.fromNumber(23),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(658),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(78),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(56),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(52),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(42),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(2678),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2050),
                int64.fromNumber(314),
                int64.fromNumber(218),
                int64.fromNumber(190),
                int64.fromNumber(124),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2050),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(314),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(218),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(190),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(124),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(2728),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2040),
                int64.fromNumber(274),
                int64.fromNumber(213),
                int64.fromNumber(144),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2040),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(274),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(213),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(144),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(2311),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(1748), int64.fromNumber(266), int64.fromNumber(148)],
              eventCounts: [
                {
                  count: int64.fromNumber(1748),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(266),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(148),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(2493),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(1857), int64.fromNumber(215)],
              eventCounts: [
                {
                  count: int64.fromNumber(1857),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(215),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(1306),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(988)],
              eventCounts: [
                {
                  count: int64.fromNumber(988),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [],
      id: 'fd3eba5e-ed48-4279-93c1-8be089fa9b7d',
    },
    {
      cohort: [
        {
          entryStart: '2022-05-29T07:00:00Z' as timestamp,
          entryEnd: '2022-05-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-30T07:00:00Z' as timestamp,
          entryEnd: '2022-05-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-31T07:00:00Z' as timestamp,
          entryEnd: '2022-06-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-01T07:00:00Z' as timestamp,
          entryEnd: '2022-06-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-02T07:00:00Z' as timestamp,
          entryEnd: '2022-06-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-03T07:00:00Z' as timestamp,
          entryEnd: '2022-06-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-04T07:00:00Z' as timestamp,
          entryEnd: '2022-06-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-05T07:00:00Z' as timestamp,
          entryEnd: '2022-06-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-06T07:00:00Z' as timestamp,
          entryEnd: '2022-06-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-07T07:00:00Z' as timestamp,
          entryEnd: '2022-06-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-08T07:00:00Z' as timestamp,
          entryEnd: '2022-06-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-09T07:00:00Z' as timestamp,
          entryEnd: '2022-06-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-10T07:00:00Z' as timestamp,
          entryEnd: '2022-06-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-11T07:00:00Z' as timestamp,
          entryEnd: '2022-06-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-12T07:00:00Z' as timestamp,
          entryEnd: '2022-06-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-13T07:00:00Z' as timestamp,
          entryEnd: '2022-06-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-14T07:00:00Z' as timestamp,
          entryEnd: '2022-06-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-15T07:00:00Z' as timestamp,
          entryEnd: '2022-06-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-16T07:00:00Z' as timestamp,
          entryEnd: '2022-06-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-17T07:00:00Z' as timestamp,
          entryEnd: '2022-06-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-18T07:00:00Z' as timestamp,
          entryEnd: '2022-06-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-19T07:00:00Z' as timestamp,
          entryEnd: '2022-06-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-20T07:00:00Z' as timestamp,
          entryEnd: '2022-06-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-21T07:00:00Z' as timestamp,
          entryEnd: '2022-06-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-22T07:00:00Z' as timestamp,
          entryEnd: '2022-06-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-23T07:00:00Z' as timestamp,
          entryEnd: '2022-06-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-24T07:00:00Z' as timestamp,
          entryEnd: '2022-06-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-25T07:00:00Z' as timestamp,
          entryEnd: '2022-06-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-26T07:00:00Z' as timestamp,
          entryEnd: '2022-06-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-27T07:00:00Z' as timestamp,
          entryEnd: '2022-06-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-28T07:00:00Z' as timestamp,
          entryEnd: '2022-06-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-29T07:00:00Z' as timestamp,
          entryEnd: '2022-06-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-01T07:00:00Z' as timestamp,
          entryEnd: '2022-07-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-02T07:00:00Z' as timestamp,
          entryEnd: '2022-07-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-03T07:00:00Z' as timestamp,
          entryEnd: '2022-07-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-04T07:00:00Z' as timestamp,
          entryEnd: '2022-07-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-05T07:00:00Z' as timestamp,
          entryEnd: '2022-07-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-06T07:00:00Z' as timestamp,
          entryEnd: '2022-07-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-07T07:00:00Z' as timestamp,
          entryEnd: '2022-07-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-08T07:00:00Z' as timestamp,
          entryEnd: '2022-07-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-09T07:00:00Z' as timestamp,
          entryEnd: '2022-07-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-10T07:00:00Z' as timestamp,
          entryEnd: '2022-07-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-11T07:00:00Z' as timestamp,
          entryEnd: '2022-07-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-12T07:00:00Z' as timestamp,
          entryEnd: '2022-07-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-13T07:00:00Z' as timestamp,
          entryEnd: '2022-07-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-14T07:00:00Z' as timestamp,
          entryEnd: '2022-07-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-15T07:00:00Z' as timestamp,
          entryEnd: '2022-07-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-16T07:00:00Z' as timestamp,
          entryEnd: '2022-07-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-17T07:00:00Z' as timestamp,
          entryEnd: '2022-07-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-18T07:00:00Z' as timestamp,
          entryEnd: '2022-07-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-19T07:00:00Z' as timestamp,
          entryEnd: '2022-07-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-20T07:00:00Z' as timestamp,
          entryEnd: '2022-07-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-21T07:00:00Z' as timestamp,
          entryEnd: '2022-07-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-22T07:00:00Z' as timestamp,
          entryEnd: '2022-07-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-23T07:00:00Z' as timestamp,
          entryEnd: '2022-07-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-24T07:00:00Z' as timestamp,
          entryEnd: '2022-07-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-25T07:00:00Z' as timestamp,
          entryEnd: '2022-07-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-26T07:00:00Z' as timestamp,
          entryEnd: '2022-07-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-27T07:00:00Z' as timestamp,
          entryEnd: '2022-07-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(9),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(9),
                int64.fromNumber(9),
                int64.fromNumber(5),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(5),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-28T07:00:00Z' as timestamp,
          entryEnd: '2022-07-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(5237),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(4701),
                int64.fromNumber(1835),
                int64.fromNumber(212),
                int64.fromNumber(244),
                int64.fromNumber(1812),
                int64.fromNumber(1813),
                int64.fromNumber(1777),
                int64.fromNumber(1703),
                int64.fromNumber(1375),
                int64.fromNumber(177),
                int64.fromNumber(199),
                int64.fromNumber(1661),
                int64.fromNumber(1644),
                int64.fromNumber(1596),
                int64.fromNumber(1547),
                int64.fromNumber(1328),
                int64.fromNumber(155),
                int64.fromNumber(164),
                int64.fromNumber(1569),
                int64.fromNumber(1512),
                int64.fromNumber(1536),
                int64.fromNumber(1496),
                int64.fromNumber(1305),
                int64.fromNumber(158),
                int64.fromNumber(171),
                int64.fromNumber(1502),
                int64.fromNumber(1517),
                int64.fromNumber(1396),
                int64.fromNumber(1510),
                int64.fromNumber(1122),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(4701),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1835),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(212),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(244),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1812),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1813),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1777),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1703),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1375),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(177),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(199),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1661),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1644),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1596),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1547),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1328),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(155),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(164),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1569),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1512),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1536),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1496),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1305),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(158),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(171),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1502),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1517),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1396),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1510),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1122),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-29T07:00:00Z' as timestamp,
          entryEnd: '2022-07-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(2653),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2245),
                int64.fromNumber(65),
                int64.fromNumber(74),
                int64.fromNumber(608),
                int64.fromNumber(535),
                int64.fromNumber(517),
                int64.fromNumber(510),
                int64.fromNumber(445),
                int64.fromNumber(41),
                int64.fromNumber(51),
                int64.fromNumber(493),
                int64.fromNumber(464),
                int64.fromNumber(491),
                int64.fromNumber(405),
                int64.fromNumber(394),
                int64.fromNumber(40),
                int64.fromNumber(37),
                int64.fromNumber(450),
                int64.fromNumber(452),
                int64.fromNumber(440),
                int64.fromNumber(408),
                int64.fromNumber(392),
                int64.fromNumber(31),
                int64.fromNumber(36),
                int64.fromNumber(416),
                int64.fromNumber(412),
                int64.fromNumber(374),
                int64.fromNumber(424),
                int64.fromNumber(316),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2245),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(65),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(74),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(608),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(535),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(517),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(510),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(445),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(41),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(51),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(493),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(464),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(491),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(405),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(394),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(40),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(450),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(452),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(440),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(408),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(392),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(36),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(416),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(412),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(374),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(424),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(316),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(289),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(172),
                int64.fromNumber(16),
                int64.fromNumber(29),
                int64.fromNumber(29),
                int64.fromNumber(27),
                int64.fromNumber(27),
                int64.fromNumber(18),
                int64.fromNumber(14),
                int64.fromNumber(12),
                int64.fromNumber(30),
                int64.fromNumber(20),
                int64.fromNumber(18),
                int64.fromNumber(19),
                int64.fromNumber(19),
                int64.fromNumber(16),
                int64.fromNumber(10),
                int64.fromNumber(23),
                int64.fromNumber(18),
                int64.fromNumber(26),
                int64.fromNumber(21),
                int64.fromNumber(18),
                int64.fromNumber(16),
                int64.fromNumber(12),
                int64.fromNumber(26),
                int64.fromNumber(23),
                int64.fromNumber(11),
                int64.fromNumber(20),
                int64.fromNumber(12),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(172),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-31T07:00:00Z' as timestamp,
          entryEnd: '2022-08-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(489),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(326),
                int64.fromNumber(50),
                int64.fromNumber(47),
                int64.fromNumber(46),
                int64.fromNumber(43),
                int64.fromNumber(33),
                int64.fromNumber(11),
                int64.fromNumber(27),
                int64.fromNumber(48),
                int64.fromNumber(43),
                int64.fromNumber(34),
                int64.fromNumber(42),
                int64.fromNumber(27),
                int64.fromNumber(7),
                int64.fromNumber(30),
                int64.fromNumber(35),
                int64.fromNumber(38),
                int64.fromNumber(27),
                int64.fromNumber(31),
                int64.fromNumber(19),
                int64.fromNumber(9),
                int64.fromNumber(16),
                int64.fromNumber(29),
                int64.fromNumber(39),
                int64.fromNumber(28),
                int64.fromNumber(44),
                int64.fromNumber(14),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(326),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(50),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(47),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(43),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(48),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(43),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(42),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(39),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(44),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-01T07:00:00Z' as timestamp,
          entryEnd: '2022-08-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(3000),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2537),
                int64.fromNumber(678),
                int64.fromNumber(556),
                int64.fromNumber(524),
                int64.fromNumber(392),
                int64.fromNumber(21),
                int64.fromNumber(31),
                int64.fromNumber(495),
                int64.fromNumber(484),
                int64.fromNumber(455),
                int64.fromNumber(421),
                int64.fromNumber(342),
                int64.fromNumber(29),
                int64.fromNumber(36),
                int64.fromNumber(437),
                int64.fromNumber(435),
                int64.fromNumber(412),
                int64.fromNumber(404),
                int64.fromNumber(336),
                int64.fromNumber(27),
                int64.fromNumber(34),
                int64.fromNumber(451),
                int64.fromNumber(399),
                int64.fromNumber(383),
                int64.fromNumber(409),
                int64.fromNumber(292),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2537),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(678),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(556),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(524),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(392),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(495),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(484),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(455),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(421),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(342),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(36),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(437),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(435),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(412),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(404),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(336),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(451),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(399),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(383),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(409),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(292),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-02T07:00:00Z' as timestamp,
          entryEnd: '2022-08-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(2621),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2117),
                int64.fromNumber(489),
                int64.fromNumber(397),
                int64.fromNumber(290),
                int64.fromNumber(17),
                int64.fromNumber(38),
                int64.fromNumber(349),
                int64.fromNumber(364),
                int64.fromNumber(292),
                int64.fromNumber(287),
                int64.fromNumber(221),
                int64.fromNumber(19),
                int64.fromNumber(20),
                int64.fromNumber(270),
                int64.fromNumber(308),
                int64.fromNumber(269),
                int64.fromNumber(259),
                int64.fromNumber(196),
                int64.fromNumber(13),
                int64.fromNumber(23),
                int64.fromNumber(278),
                int64.fromNumber(281),
                int64.fromNumber(266),
                int64.fromNumber(267),
                int64.fromNumber(195),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2117),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(489),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(397),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(290),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(349),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(364),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(292),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(287),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(221),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(270),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(308),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(269),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(259),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(196),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(278),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(281),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(266),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(267),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(195),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-03T07:00:00Z' as timestamp,
          entryEnd: '2022-08-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(2338),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1858),
                int64.fromNumber(341),
                int64.fromNumber(236),
                int64.fromNumber(9),
                int64.fromNumber(20),
                int64.fromNumber(255),
                int64.fromNumber(251),
                int64.fromNumber(245),
                int64.fromNumber(221),
                int64.fromNumber(173),
                int64.fromNumber(13),
                int64.fromNumber(11),
                int64.fromNumber(213),
                int64.fromNumber(192),
                int64.fromNumber(209),
                int64.fromNumber(186),
                int64.fromNumber(173),
                int64.fromNumber(8),
                int64.fromNumber(14),
                int64.fromNumber(214),
                int64.fromNumber(201),
                int64.fromNumber(194),
                int64.fromNumber(206),
                int64.fromNumber(142),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1858),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(341),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(236),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(255),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(251),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(245),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(221),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(173),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(213),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(192),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(209),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(186),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(173),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(214),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(201),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(194),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(206),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(142),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-04T07:00:00Z' as timestamp,
          entryEnd: '2022-08-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(2057),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1618),
                int64.fromNumber(253),
                int64.fromNumber(11),
                int64.fromNumber(19),
                int64.fromNumber(194),
                int64.fromNumber(189),
                int64.fromNumber(178),
                int64.fromNumber(156),
                int64.fromNumber(105),
                int64.fromNumber(17),
                int64.fromNumber(14),
                int64.fromNumber(160),
                int64.fromNumber(154),
                int64.fromNumber(150),
                int64.fromNumber(174),
                int64.fromNumber(103),
                int64.fromNumber(7),
                int64.fromNumber(13),
                int64.fromNumber(160),
                int64.fromNumber(150),
                int64.fromNumber(145),
                int64.fromNumber(155),
                int64.fromNumber(114),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1618),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(253),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(194),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(189),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(178),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(156),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(105),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(160),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(154),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(150),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(174),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(103),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(160),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(150),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(145),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(155),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(114),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-05T07:00:00Z' as timestamp,
          entryEnd: '2022-08-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(1467),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1138),
                int64.fromNumber(25),
                int64.fromNumber(22),
                int64.fromNumber(154),
                int64.fromNumber(123),
                int64.fromNumber(121),
                int64.fromNumber(114),
                int64.fromNumber(81),
                int64.fromNumber(11),
                int64.fromNumber(8),
                int64.fromNumber(108),
                int64.fromNumber(98),
                int64.fromNumber(101),
                int64.fromNumber(90),
                int64.fromNumber(96),
                int64.fromNumber(6),
                int64.fromNumber(8),
                int64.fromNumber(100),
                int64.fromNumber(97),
                int64.fromNumber(80),
                int64.fromNumber(72),
                int64.fromNumber(55),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1138),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(154),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(123),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(121),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(114),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(81),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(108),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(98),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(101),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(90),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(96),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(100),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(97),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(80),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(72),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(55),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-06T07:00:00Z' as timestamp,
          entryEnd: '2022-08-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(420),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(241),
                int64.fromNumber(11),
                int64.fromNumber(6),
                int64.fromNumber(13),
                int64.fromNumber(3),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(9),
                int64.fromNumber(9),
                int64.fromNumber(9),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(6),
                int64.fromNumber(8),
                int64.fromNumber(3),
                int64.fromNumber(5),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(241),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-07T07:00:00Z' as timestamp,
          entryEnd: '2022-08-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(394),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(252),
                int64.fromNumber(25),
                int64.fromNumber(14),
                int64.fromNumber(17),
                int64.fromNumber(21),
                int64.fromNumber(13),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(13),
                int64.fromNumber(9),
                int64.fromNumber(14),
                int64.fromNumber(9),
                int64.fromNumber(8),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(12),
                int64.fromNumber(11),
                int64.fromNumber(8),
                int64.fromNumber(9),
                int64.fromNumber(6),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(252),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-08T07:00:00Z' as timestamp,
          entryEnd: '2022-08-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(2012),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1541),
                int64.fromNumber(256),
                int64.fromNumber(167),
                int64.fromNumber(178),
                int64.fromNumber(137),
                int64.fromNumber(12),
                int64.fromNumber(9),
                int64.fromNumber(150),
                int64.fromNumber(145),
                int64.fromNumber(128),
                int64.fromNumber(150),
                int64.fromNumber(107),
                int64.fromNumber(10),
                int64.fromNumber(14),
                int64.fromNumber(140),
                int64.fromNumber(135),
                int64.fromNumber(118),
                int64.fromNumber(134),
                int64.fromNumber(92),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1541),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(256),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(167),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(178),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(137),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(150),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(145),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(128),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(150),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(107),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(140),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(135),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(118),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(134),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(92),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-09T07:00:00Z' as timestamp,
          entryEnd: '2022-08-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(1882),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1445),
                int64.fromNumber(238),
                int64.fromNumber(157),
                int64.fromNumber(102),
                int64.fromNumber(11),
                int64.fromNumber(14),
                int64.fromNumber(114),
                int64.fromNumber(128),
                int64.fromNumber(116),
                int64.fromNumber(105),
                int64.fromNumber(94),
                int64.fromNumber(8),
                int64.fromNumber(15),
                int64.fromNumber(115),
                int64.fromNumber(118),
                int64.fromNumber(87),
                int64.fromNumber(103),
                int64.fromNumber(87),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1445),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(238),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(157),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(102),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(114),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(128),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(116),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(105),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(94),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(115),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(118),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(87),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(103),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(87),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-10T07:00:00Z' as timestamp,
          entryEnd: '2022-08-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(1871),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1446),
                int64.fromNumber(190),
                int64.fromNumber(118),
                int64.fromNumber(12),
                int64.fromNumber(19),
                int64.fromNumber(118),
                int64.fromNumber(121),
                int64.fromNumber(124),
                int64.fromNumber(122),
                int64.fromNumber(70),
                int64.fromNumber(4),
                int64.fromNumber(10),
                int64.fromNumber(101),
                int64.fromNumber(115),
                int64.fromNumber(106),
                int64.fromNumber(96),
                int64.fromNumber(64),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1446),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(190),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(118),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(118),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(121),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(124),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(122),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(70),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(101),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(115),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(106),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(96),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(64),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-11T07:00:00Z' as timestamp,
          entryEnd: '2022-08-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(1506),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1189),
                int64.fromNumber(134),
                int64.fromNumber(5),
                int64.fromNumber(13),
                int64.fromNumber(115),
                int64.fromNumber(114),
                int64.fromNumber(85),
                int64.fromNumber(76),
                int64.fromNumber(70),
                int64.fromNumber(7),
                int64.fromNumber(5),
                int64.fromNumber(62),
                int64.fromNumber(85),
                int64.fromNumber(71),
                int64.fromNumber(72),
                int64.fromNumber(46),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1189),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(134),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(115),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(114),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(85),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(76),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(70),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(62),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(85),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(71),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(72),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-12T07:00:00Z' as timestamp,
          entryEnd: '2022-08-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(1282),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(972),
                int64.fromNumber(19),
                int64.fromNumber(10),
                int64.fromNumber(117),
                int64.fromNumber(82),
                int64.fromNumber(80),
                int64.fromNumber(76),
                int64.fromNumber(70),
                int64.fromNumber(3),
                int64.fromNumber(8),
                int64.fromNumber(56),
                int64.fromNumber(61),
                int64.fromNumber(57),
                int64.fromNumber(60),
                int64.fromNumber(37),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(972),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(117),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(82),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(80),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(76),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(70),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(56),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(61),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(57),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(60),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-13T07:00:00Z' as timestamp,
          entryEnd: '2022-08-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(267),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(147),
                int64.fromNumber(10),
                int64.fromNumber(13),
                int64.fromNumber(10),
                int64.fromNumber(8),
                int64.fromNumber(6),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(5),
                int64.fromNumber(8),
                int64.fromNumber(7),
                int64.fromNumber(5),
                int64.fromNumber(4),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(147),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-14T07:00:00Z' as timestamp,
          entryEnd: '2022-08-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(415),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(272),
                int64.fromNumber(19),
                int64.fromNumber(15),
                int64.fromNumber(5),
                int64.fromNumber(6),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(8),
                int64.fromNumber(7),
                int64.fromNumber(6),
                int64.fromNumber(10),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(272),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-15T07:00:00Z' as timestamp,
          entryEnd: '2022-08-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(1643),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1319),
                int64.fromNumber(183),
                int64.fromNumber(130),
                int64.fromNumber(119),
                int64.fromNumber(70),
                int64.fromNumber(2),
                int64.fromNumber(4),
                int64.fromNumber(97),
                int64.fromNumber(98),
                int64.fromNumber(74),
                int64.fromNumber(94),
                int64.fromNumber(50),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1319),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(183),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(130),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(119),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(70),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(97),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(98),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(74),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(94),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(50),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-16T07:00:00Z' as timestamp,
          entryEnd: '2022-08-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(1657),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1269),
                int64.fromNumber(180),
                int64.fromNumber(127),
                int64.fromNumber(86),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(104),
                int64.fromNumber(105),
                int64.fromNumber(87),
                int64.fromNumber(87),
                int64.fromNumber(62),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1269),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(180),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(127),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(86),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(104),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(105),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(87),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(87),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(62),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-17T07:00:00Z' as timestamp,
          entryEnd: '2022-08-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(1481),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1121),
                int64.fromNumber(130),
                int64.fromNumber(79),
                int64.fromNumber(11),
                int64.fromNumber(7),
                int64.fromNumber(71),
                int64.fromNumber(74),
                int64.fromNumber(60),
                int64.fromNumber(60),
                int64.fromNumber(52),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1121),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(130),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(79),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(71),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(74),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(60),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(60),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(52),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-18T07:00:00Z' as timestamp,
          entryEnd: '2022-08-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(1487),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1117),
                int64.fromNumber(100),
                int64.fromNumber(9),
                int64.fromNumber(7),
                int64.fromNumber(89),
                int64.fromNumber(76),
                int64.fromNumber(59),
                int64.fromNumber(74),
                int64.fromNumber(47),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1117),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(100),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(89),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(76),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(59),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(74),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(47),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-19T07:00:00Z' as timestamp,
          entryEnd: '2022-08-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(1054),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(789),
                int64.fromNumber(7),
                int64.fromNumber(10),
                int64.fromNumber(83),
                int64.fromNumber(63),
                int64.fromNumber(58),
                int64.fromNumber(56),
                int64.fromNumber(27),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(789),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(83),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(63),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(58),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(56),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(224),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(148),
                int64.fromNumber(2),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(7),
                int64.fromNumber(2),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(148),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(353),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(213),
                int64.fromNumber(8),
                int64.fromNumber(7),
                int64.fromNumber(6),
                int64.fromNumber(7),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(213),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(1428),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1107),
                int64.fromNumber(144),
                int64.fromNumber(102),
                int64.fromNumber(89),
                int64.fromNumber(56),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1107),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(144),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(102),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(89),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(56),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(1505),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1120),
                int64.fromNumber(130),
                int64.fromNumber(91),
                int64.fromNumber(59),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1120),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(130),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(91),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(59),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(1193),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(914), int64.fromNumber(117), int64.fromNumber(57)],
              eventCounts: [
                {
                  count: int64.fromNumber(914),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(117),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(57),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(1387),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(1036), int64.fromNumber(95)],
              eventCounts: [
                {
                  count: int64.fromNumber(1036),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(95),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(720),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(552)],
              eventCounts: [
                {
                  count: int64.fromNumber(552),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'United States',
          fallback: false,
        },
      ],
      id: 'd5a70546-b600-4388-b047-55d319b25130',
    },
    {
      cohort: [
        {
          entryStart: '2022-05-29T07:00:00Z' as timestamp,
          entryEnd: '2022-05-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-30T07:00:00Z' as timestamp,
          entryEnd: '2022-05-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-31T07:00:00Z' as timestamp,
          entryEnd: '2022-06-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-01T07:00:00Z' as timestamp,
          entryEnd: '2022-06-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-02T07:00:00Z' as timestamp,
          entryEnd: '2022-06-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-03T07:00:00Z' as timestamp,
          entryEnd: '2022-06-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-04T07:00:00Z' as timestamp,
          entryEnd: '2022-06-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-05T07:00:00Z' as timestamp,
          entryEnd: '2022-06-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-06T07:00:00Z' as timestamp,
          entryEnd: '2022-06-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-07T07:00:00Z' as timestamp,
          entryEnd: '2022-06-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-08T07:00:00Z' as timestamp,
          entryEnd: '2022-06-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-09T07:00:00Z' as timestamp,
          entryEnd: '2022-06-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-10T07:00:00Z' as timestamp,
          entryEnd: '2022-06-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-11T07:00:00Z' as timestamp,
          entryEnd: '2022-06-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-12T07:00:00Z' as timestamp,
          entryEnd: '2022-06-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-13T07:00:00Z' as timestamp,
          entryEnd: '2022-06-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-14T07:00:00Z' as timestamp,
          entryEnd: '2022-06-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-15T07:00:00Z' as timestamp,
          entryEnd: '2022-06-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-16T07:00:00Z' as timestamp,
          entryEnd: '2022-06-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-17T07:00:00Z' as timestamp,
          entryEnd: '2022-06-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-18T07:00:00Z' as timestamp,
          entryEnd: '2022-06-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-19T07:00:00Z' as timestamp,
          entryEnd: '2022-06-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-20T07:00:00Z' as timestamp,
          entryEnd: '2022-06-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-21T07:00:00Z' as timestamp,
          entryEnd: '2022-06-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-22T07:00:00Z' as timestamp,
          entryEnd: '2022-06-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-23T07:00:00Z' as timestamp,
          entryEnd: '2022-06-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-24T07:00:00Z' as timestamp,
          entryEnd: '2022-06-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-25T07:00:00Z' as timestamp,
          entryEnd: '2022-06-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-26T07:00:00Z' as timestamp,
          entryEnd: '2022-06-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-27T07:00:00Z' as timestamp,
          entryEnd: '2022-06-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-28T07:00:00Z' as timestamp,
          entryEnd: '2022-06-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-29T07:00:00Z' as timestamp,
          entryEnd: '2022-06-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-01T07:00:00Z' as timestamp,
          entryEnd: '2022-07-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-02T07:00:00Z' as timestamp,
          entryEnd: '2022-07-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-03T07:00:00Z' as timestamp,
          entryEnd: '2022-07-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-04T07:00:00Z' as timestamp,
          entryEnd: '2022-07-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-05T07:00:00Z' as timestamp,
          entryEnd: '2022-07-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-06T07:00:00Z' as timestamp,
          entryEnd: '2022-07-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-07T07:00:00Z' as timestamp,
          entryEnd: '2022-07-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-08T07:00:00Z' as timestamp,
          entryEnd: '2022-07-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-09T07:00:00Z' as timestamp,
          entryEnd: '2022-07-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-10T07:00:00Z' as timestamp,
          entryEnd: '2022-07-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-11T07:00:00Z' as timestamp,
          entryEnd: '2022-07-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-12T07:00:00Z' as timestamp,
          entryEnd: '2022-07-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-13T07:00:00Z' as timestamp,
          entryEnd: '2022-07-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-14T07:00:00Z' as timestamp,
          entryEnd: '2022-07-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-15T07:00:00Z' as timestamp,
          entryEnd: '2022-07-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-16T07:00:00Z' as timestamp,
          entryEnd: '2022-07-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-17T07:00:00Z' as timestamp,
          entryEnd: '2022-07-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-18T07:00:00Z' as timestamp,
          entryEnd: '2022-07-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-19T07:00:00Z' as timestamp,
          entryEnd: '2022-07-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-20T07:00:00Z' as timestamp,
          entryEnd: '2022-07-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-21T07:00:00Z' as timestamp,
          entryEnd: '2022-07-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-22T07:00:00Z' as timestamp,
          entryEnd: '2022-07-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-23T07:00:00Z' as timestamp,
          entryEnd: '2022-07-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-24T07:00:00Z' as timestamp,
          entryEnd: '2022-07-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-25T07:00:00Z' as timestamp,
          entryEnd: '2022-07-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-26T07:00:00Z' as timestamp,
          entryEnd: '2022-07-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-27T07:00:00Z' as timestamp,
          entryEnd: '2022-07-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(27),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(25),
                int64.fromNumber(20),
                int64.fromNumber(13),
                int64.fromNumber(5),
                int64.fromNumber(14),
                int64.fromNumber(15),
                int64.fromNumber(16),
                int64.fromNumber(12),
                int64.fromNumber(12),
                int64.fromNumber(12),
                int64.fromNumber(2),
                int64.fromNumber(5),
                int64.fromNumber(11),
                int64.fromNumber(12),
                int64.fromNumber(13),
                int64.fromNumber(12),
                int64.fromNumber(9),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(8),
                int64.fromNumber(13),
                int64.fromNumber(9),
                int64.fromNumber(11),
                int64.fromNumber(5),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(8),
                int64.fromNumber(9),
                int64.fromNumber(9),
                int64.fromNumber(12),
                int64.fromNumber(9),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-28T07:00:00Z' as timestamp,
          entryEnd: '2022-07-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(398),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(347),
                int64.fromNumber(106),
                int64.fromNumber(21),
                int64.fromNumber(62),
                int64.fromNumber(123),
                int64.fromNumber(115),
                int64.fromNumber(113),
                int64.fromNumber(99),
                int64.fromNumber(89),
                int64.fromNumber(19),
                int64.fromNumber(44),
                int64.fromNumber(93),
                int64.fromNumber(96),
                int64.fromNumber(93),
                int64.fromNumber(74),
                int64.fromNumber(63),
                int64.fromNumber(17),
                int64.fromNumber(19),
                int64.fromNumber(56),
                int64.fromNumber(85),
                int64.fromNumber(91),
                int64.fromNumber(85),
                int64.fromNumber(53),
                int64.fromNumber(16),
                int64.fromNumber(47),
                int64.fromNumber(90),
                int64.fromNumber(84),
                int64.fromNumber(84),
                int64.fromNumber(104),
                int64.fromNumber(61),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(347),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(106),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(62),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(123),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(115),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(113),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(99),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(89),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(44),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(93),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(96),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(93),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(74),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(63),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(56),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(85),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(91),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(85),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(53),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(47),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(90),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(84),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(84),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(104),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(61),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-29T07:00:00Z' as timestamp,
          entryEnd: '2022-07-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(198),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(162),
                int64.fromNumber(2),
                int64.fromNumber(15),
                int64.fromNumber(29),
                int64.fromNumber(26),
                int64.fromNumber(29),
                int64.fromNumber(22),
                int64.fromNumber(19),
                int64.fromNumber(1),
                int64.fromNumber(10),
                int64.fromNumber(20),
                int64.fromNumber(24),
                int64.fromNumber(20),
                int64.fromNumber(19),
                int64.fromNumber(13),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(9),
                int64.fromNumber(17),
                int64.fromNumber(12),
                int64.fromNumber(13),
                int64.fromNumber(16),
                int64.fromNumber(2),
                int64.fromNumber(7),
                int64.fromNumber(20),
                int64.fromNumber(14),
                int64.fromNumber(18),
                int64.fromNumber(14),
                int64.fromNumber(12),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(162),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(50),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(30),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-31T07:00:00Z' as timestamp,
          entryEnd: '2022-08-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(114),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(87),
                int64.fromNumber(19),
                int64.fromNumber(14),
                int64.fromNumber(12),
                int64.fromNumber(10),
                int64.fromNumber(7),
                int64.fromNumber(5),
                int64.fromNumber(9),
                int64.fromNumber(9),
                int64.fromNumber(9),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(8),
                int64.fromNumber(5),
                int64.fromNumber(8),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(6),
                int64.fromNumber(7),
                int64.fromNumber(9),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(87),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-01T07:00:00Z' as timestamp,
          entryEnd: '2022-08-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(280),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(233),
                int64.fromNumber(39),
                int64.fromNumber(31),
                int64.fromNumber(33),
                int64.fromNumber(14),
                int64.fromNumber(0),
                int64.fromNumber(12),
                int64.fromNumber(30),
                int64.fromNumber(26),
                int64.fromNumber(19),
                int64.fromNumber(22),
                int64.fromNumber(11),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(12),
                int64.fromNumber(29),
                int64.fromNumber(18),
                int64.fromNumber(18),
                int64.fromNumber(13),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(26),
                int64.fromNumber(23),
                int64.fromNumber(26),
                int64.fromNumber(24),
                int64.fromNumber(25),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(233),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(39),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-02T07:00:00Z' as timestamp,
          entryEnd: '2022-08-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(236),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(192),
                int64.fromNumber(46),
                int64.fromNumber(22),
                int64.fromNumber(13),
                int64.fromNumber(5),
                int64.fromNumber(11),
                int64.fromNumber(18),
                int64.fromNumber(8),
                int64.fromNumber(11),
                int64.fromNumber(18),
                int64.fromNumber(9),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(10),
                int64.fromNumber(13),
                int64.fromNumber(9),
                int64.fromNumber(10),
                int64.fromNumber(6),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(13),
                int64.fromNumber(15),
                int64.fromNumber(12),
                int64.fromNumber(17),
                int64.fromNumber(16),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(192),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-03T07:00:00Z' as timestamp,
          entryEnd: '2022-08-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(242),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(191),
                int64.fromNumber(23),
                int64.fromNumber(16),
                int64.fromNumber(3),
                int64.fromNumber(9),
                int64.fromNumber(16),
                int64.fromNumber(17),
                int64.fromNumber(16),
                int64.fromNumber(13),
                int64.fromNumber(10),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(8),
                int64.fromNumber(15),
                int64.fromNumber(13),
                int64.fromNumber(8),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(10),
                int64.fromNumber(11),
                int64.fromNumber(12),
                int64.fromNumber(14),
                int64.fromNumber(4),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(191),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-04T07:00:00Z' as timestamp,
          entryEnd: '2022-08-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(230),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(167),
                int64.fromNumber(31),
                int64.fromNumber(1),
                int64.fromNumber(10),
                int64.fromNumber(14),
                int64.fromNumber(15),
                int64.fromNumber(12),
                int64.fromNumber(12),
                int64.fromNumber(7),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(7),
                int64.fromNumber(11),
                int64.fromNumber(8),
                int64.fromNumber(12),
                int64.fromNumber(7),
                int64.fromNumber(2),
                int64.fromNumber(5),
                int64.fromNumber(12),
                int64.fromNumber(6),
                int64.fromNumber(6),
                int64.fromNumber(10),
                int64.fromNumber(6),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(167),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-05T07:00:00Z' as timestamp,
          entryEnd: '2022-08-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(143),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(110),
                int64.fromNumber(9),
                int64.fromNumber(7),
                int64.fromNumber(6),
                int64.fromNumber(8),
                int64.fromNumber(7),
                int64.fromNumber(7),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(7),
                int64.fromNumber(7),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(8),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(110),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-06T07:00:00Z' as timestamp,
          entryEnd: '2022-08-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(44),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(29),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-07T07:00:00Z' as timestamp,
          entryEnd: '2022-08-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(94),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(70),
                int64.fromNumber(18),
                int64.fromNumber(5),
                int64.fromNumber(6),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(1),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(5),
                int64.fromNumber(1),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(70),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-08T07:00:00Z' as timestamp,
          entryEnd: '2022-08-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(191),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(149),
                int64.fromNumber(15),
                int64.fromNumber(9),
                int64.fromNumber(10),
                int64.fromNumber(8),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(7),
                int64.fromNumber(10),
                int64.fromNumber(5),
                int64.fromNumber(10),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(12),
                int64.fromNumber(16),
                int64.fromNumber(9),
                int64.fromNumber(10),
                int64.fromNumber(8),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(149),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-09T07:00:00Z' as timestamp,
          entryEnd: '2022-08-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(166),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(126),
                int64.fromNumber(21),
                int64.fromNumber(17),
                int64.fromNumber(8),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(7),
                int64.fromNumber(9),
                int64.fromNumber(12),
                int64.fromNumber(9),
                int64.fromNumber(5),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(7),
                int64.fromNumber(7),
                int64.fromNumber(7),
                int64.fromNumber(9),
                int64.fromNumber(5),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(126),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-10T07:00:00Z' as timestamp,
          entryEnd: '2022-08-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(189),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(147),
                int64.fromNumber(20),
                int64.fromNumber(7),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(4),
                int64.fromNumber(10),
                int64.fromNumber(11),
                int64.fromNumber(7),
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(8),
                int64.fromNumber(15),
                int64.fromNumber(11),
                int64.fromNumber(15),
                int64.fromNumber(9),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(147),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-11T07:00:00Z' as timestamp,
          entryEnd: '2022-08-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(134),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(98),
                int64.fromNumber(15),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(9),
                int64.fromNumber(5),
                int64.fromNumber(6),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(6),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(98),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-12T07:00:00Z' as timestamp,
          entryEnd: '2022-08-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(103),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(80),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(7),
                int64.fromNumber(5),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(9),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(80),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-13T07:00:00Z' as timestamp,
          entryEnd: '2022-08-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(47),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(32),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-14T07:00:00Z' as timestamp,
          entryEnd: '2022-08-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(34),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(22),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-15T07:00:00Z' as timestamp,
          entryEnd: '2022-08-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(98),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(66),
                int64.fromNumber(16),
                int64.fromNumber(8),
                int64.fromNumber(9),
                int64.fromNumber(7),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(7),
                int64.fromNumber(4),
                int64.fromNumber(7),
                int64.fromNumber(5),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(66),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-16T07:00:00Z' as timestamp,
          entryEnd: '2022-08-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(143),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(103),
                int64.fromNumber(12),
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(103),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-17T07:00:00Z' as timestamp,
          entryEnd: '2022-08-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(169),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(131),
                int64.fromNumber(19),
                int64.fromNumber(7),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(7),
                int64.fromNumber(8),
                int64.fromNumber(6),
                int64.fromNumber(4),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(131),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-18T07:00:00Z' as timestamp,
          entryEnd: '2022-08-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(137),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(100),
                int64.fromNumber(9),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(7),
                int64.fromNumber(6),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(100),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-19T07:00:00Z' as timestamp,
          entryEnd: '2022-08-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(102),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(74),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(74),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(41),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(28),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(86),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(59),
                int64.fromNumber(8),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(6),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(59),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(177),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(132),
                int64.fromNumber(20),
                int64.fromNumber(5),
                int64.fromNumber(6),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(132),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(175),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(129),
                int64.fromNumber(18),
                int64.fromNumber(10),
                int64.fromNumber(7),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(129),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(148),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(111), int64.fromNumber(17), int64.fromNumber(6)],
              eventCounts: [
                {
                  count: int64.fromNumber(111),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(155),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(116), int64.fromNumber(14)],
              eventCounts: [
                {
                  count: int64.fromNumber(116),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(79),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(54)],
              eventCounts: [
                {
                  count: int64.fromNumber(54),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'India',
          fallback: false,
        },
      ],
      id: 'b26d9c01-0b35-4c95-9224-dcaf4143a1f8',
    },
    {
      cohort: [
        {
          entryStart: '2022-05-29T07:00:00Z' as timestamp,
          entryEnd: '2022-05-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-30T07:00:00Z' as timestamp,
          entryEnd: '2022-05-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-31T07:00:00Z' as timestamp,
          entryEnd: '2022-06-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-01T07:00:00Z' as timestamp,
          entryEnd: '2022-06-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-02T07:00:00Z' as timestamp,
          entryEnd: '2022-06-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-03T07:00:00Z' as timestamp,
          entryEnd: '2022-06-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-04T07:00:00Z' as timestamp,
          entryEnd: '2022-06-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-05T07:00:00Z' as timestamp,
          entryEnd: '2022-06-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-06T07:00:00Z' as timestamp,
          entryEnd: '2022-06-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-07T07:00:00Z' as timestamp,
          entryEnd: '2022-06-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-08T07:00:00Z' as timestamp,
          entryEnd: '2022-06-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-09T07:00:00Z' as timestamp,
          entryEnd: '2022-06-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-10T07:00:00Z' as timestamp,
          entryEnd: '2022-06-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-11T07:00:00Z' as timestamp,
          entryEnd: '2022-06-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-12T07:00:00Z' as timestamp,
          entryEnd: '2022-06-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-13T07:00:00Z' as timestamp,
          entryEnd: '2022-06-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-14T07:00:00Z' as timestamp,
          entryEnd: '2022-06-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-15T07:00:00Z' as timestamp,
          entryEnd: '2022-06-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-16T07:00:00Z' as timestamp,
          entryEnd: '2022-06-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-17T07:00:00Z' as timestamp,
          entryEnd: '2022-06-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-18T07:00:00Z' as timestamp,
          entryEnd: '2022-06-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-19T07:00:00Z' as timestamp,
          entryEnd: '2022-06-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-20T07:00:00Z' as timestamp,
          entryEnd: '2022-06-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-21T07:00:00Z' as timestamp,
          entryEnd: '2022-06-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-22T07:00:00Z' as timestamp,
          entryEnd: '2022-06-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-23T07:00:00Z' as timestamp,
          entryEnd: '2022-06-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-24T07:00:00Z' as timestamp,
          entryEnd: '2022-06-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-25T07:00:00Z' as timestamp,
          entryEnd: '2022-06-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-26T07:00:00Z' as timestamp,
          entryEnd: '2022-06-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-27T07:00:00Z' as timestamp,
          entryEnd: '2022-06-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-28T07:00:00Z' as timestamp,
          entryEnd: '2022-06-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-29T07:00:00Z' as timestamp,
          entryEnd: '2022-06-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-01T07:00:00Z' as timestamp,
          entryEnd: '2022-07-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-02T07:00:00Z' as timestamp,
          entryEnd: '2022-07-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-03T07:00:00Z' as timestamp,
          entryEnd: '2022-07-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-04T07:00:00Z' as timestamp,
          entryEnd: '2022-07-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-05T07:00:00Z' as timestamp,
          entryEnd: '2022-07-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-06T07:00:00Z' as timestamp,
          entryEnd: '2022-07-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-07T07:00:00Z' as timestamp,
          entryEnd: '2022-07-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-08T07:00:00Z' as timestamp,
          entryEnd: '2022-07-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-09T07:00:00Z' as timestamp,
          entryEnd: '2022-07-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-10T07:00:00Z' as timestamp,
          entryEnd: '2022-07-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-11T07:00:00Z' as timestamp,
          entryEnd: '2022-07-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-12T07:00:00Z' as timestamp,
          entryEnd: '2022-07-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-13T07:00:00Z' as timestamp,
          entryEnd: '2022-07-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-14T07:00:00Z' as timestamp,
          entryEnd: '2022-07-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-15T07:00:00Z' as timestamp,
          entryEnd: '2022-07-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-16T07:00:00Z' as timestamp,
          entryEnd: '2022-07-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-17T07:00:00Z' as timestamp,
          entryEnd: '2022-07-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-18T07:00:00Z' as timestamp,
          entryEnd: '2022-07-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-19T07:00:00Z' as timestamp,
          entryEnd: '2022-07-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-20T07:00:00Z' as timestamp,
          entryEnd: '2022-07-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-21T07:00:00Z' as timestamp,
          entryEnd: '2022-07-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-22T07:00:00Z' as timestamp,
          entryEnd: '2022-07-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-23T07:00:00Z' as timestamp,
          entryEnd: '2022-07-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-24T07:00:00Z' as timestamp,
          entryEnd: '2022-07-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-25T07:00:00Z' as timestamp,
          entryEnd: '2022-07-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-26T07:00:00Z' as timestamp,
          entryEnd: '2022-07-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-27T07:00:00Z' as timestamp,
          entryEnd: '2022-07-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(1),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-28T07:00:00Z' as timestamp,
          entryEnd: '2022-07-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(431),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(383),
                int64.fromNumber(126),
                int64.fromNumber(12),
                int64.fromNumber(10),
                int64.fromNumber(59),
                int64.fromNumber(123),
                int64.fromNumber(116),
                int64.fromNumber(113),
                int64.fromNumber(85),
                int64.fromNumber(9),
                int64.fromNumber(11),
                int64.fromNumber(109),
                int64.fromNumber(104),
                int64.fromNumber(109),
                int64.fromNumber(99),
                int64.fromNumber(91),
                int64.fromNumber(10),
                int64.fromNumber(11),
                int64.fromNumber(104),
                int64.fromNumber(113),
                int64.fromNumber(109),
                int64.fromNumber(90),
                int64.fromNumber(90),
                int64.fromNumber(13),
                int64.fromNumber(15),
                int64.fromNumber(105),
                int64.fromNumber(100),
                int64.fromNumber(94),
                int64.fromNumber(95),
                int64.fromNumber(81),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(383),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(126),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(59),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(123),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(116),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(113),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(85),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(109),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(104),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(109),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(99),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(91),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(104),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(113),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(109),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(90),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(90),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(105),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(100),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(94),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(95),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(81),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-29T07:00:00Z' as timestamp,
          entryEnd: '2022-07-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(182),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(158),
                int64.fromNumber(3),
                int64.fromNumber(10),
                int64.fromNumber(20),
                int64.fromNumber(33),
                int64.fromNumber(35),
                int64.fromNumber(43),
                int64.fromNumber(37),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(41),
                int64.fromNumber(28),
                int64.fromNumber(30),
                int64.fromNumber(27),
                int64.fromNumber(28),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(30),
                int64.fromNumber(42),
                int64.fromNumber(31),
                int64.fromNumber(34),
                int64.fromNumber(25),
                int64.fromNumber(8),
                int64.fromNumber(5),
                int64.fromNumber(25),
                int64.fromNumber(32),
                int64.fromNumber(26),
                int64.fromNumber(34),
                int64.fromNumber(24),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(158),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(43),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(41),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(42),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(23),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(20),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(7),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-31T07:00:00Z' as timestamp,
          entryEnd: '2022-08-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(56),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(40),
                int64.fromNumber(8),
                int64.fromNumber(8),
                int64.fromNumber(8),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(8),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(4),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(40),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-01T07:00:00Z' as timestamp,
          entryEnd: '2022-08-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(98),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(74),
                int64.fromNumber(10),
                int64.fromNumber(14),
                int64.fromNumber(10),
                int64.fromNumber(10),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(13),
                int64.fromNumber(13),
                int64.fromNumber(8),
                int64.fromNumber(6),
                int64.fromNumber(7),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(11),
                int64.fromNumber(9),
                int64.fromNumber(15),
                int64.fromNumber(12),
                int64.fromNumber(12),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(14),
                int64.fromNumber(14),
                int64.fromNumber(8),
                int64.fromNumber(8),
                int64.fromNumber(7),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(74),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-02T07:00:00Z' as timestamp,
          entryEnd: '2022-08-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(215),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(181),
                int64.fromNumber(46),
                int64.fromNumber(39),
                int64.fromNumber(32),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(41),
                int64.fromNumber(36),
                int64.fromNumber(32),
                int64.fromNumber(23),
                int64.fromNumber(22),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(32),
                int64.fromNumber(32),
                int64.fromNumber(23),
                int64.fromNumber(24),
                int64.fromNumber(20),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(25),
                int64.fromNumber(26),
                int64.fromNumber(20),
                int64.fromNumber(28),
                int64.fromNumber(25),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(181),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(39),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(41),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(36),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-03T07:00:00Z' as timestamp,
          entryEnd: '2022-08-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(205),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(179),
                int64.fromNumber(27),
                int64.fromNumber(19),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(17),
                int64.fromNumber(22),
                int64.fromNumber(20),
                int64.fromNumber(11),
                int64.fromNumber(13),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(20),
                int64.fromNumber(23),
                int64.fromNumber(22),
                int64.fromNumber(18),
                int64.fromNumber(12),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(19),
                int64.fromNumber(14),
                int64.fromNumber(20),
                int64.fromNumber(18),
                int64.fromNumber(13),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(179),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-04T07:00:00Z' as timestamp,
          entryEnd: '2022-08-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(221),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(177),
                int64.fromNumber(21),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(23),
                int64.fromNumber(22),
                int64.fromNumber(13),
                int64.fromNumber(15),
                int64.fromNumber(17),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(10),
                int64.fromNumber(11),
                int64.fromNumber(14),
                int64.fromNumber(16),
                int64.fromNumber(10),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(18),
                int64.fromNumber(14),
                int64.fromNumber(17),
                int64.fromNumber(13),
                int64.fromNumber(9),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(177),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-05T07:00:00Z' as timestamp,
          entryEnd: '2022-08-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(167),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(132),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(24),
                int64.fromNumber(16),
                int64.fromNumber(17),
                int64.fromNumber(12),
                int64.fromNumber(8),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(15),
                int64.fromNumber(12),
                int64.fromNumber(13),
                int64.fromNumber(13),
                int64.fromNumber(6),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(10),
                int64.fromNumber(10),
                int64.fromNumber(8),
                int64.fromNumber(10),
                int64.fromNumber(7),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(132),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-06T07:00:00Z' as timestamp,
          entryEnd: '2022-08-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(39),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(34),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-07T07:00:00Z' as timestamp,
          entryEnd: '2022-08-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(40),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(30),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-08T07:00:00Z' as timestamp,
          entryEnd: '2022-08-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(198),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(142),
                int64.fromNumber(24),
                int64.fromNumber(20),
                int64.fromNumber(17),
                int64.fromNumber(14),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(23),
                int64.fromNumber(18),
                int64.fromNumber(15),
                int64.fromNumber(18),
                int64.fromNumber(12),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(18),
                int64.fromNumber(17),
                int64.fromNumber(15),
                int64.fromNumber(17),
                int64.fromNumber(6),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(142),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-09T07:00:00Z' as timestamp,
          entryEnd: '2022-08-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(157),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(125),
                int64.fromNumber(17),
                int64.fromNumber(20),
                int64.fromNumber(14),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(15),
                int64.fromNumber(9),
                int64.fromNumber(15),
                int64.fromNumber(8),
                int64.fromNumber(11),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(11),
                int64.fromNumber(8),
                int64.fromNumber(12),
                int64.fromNumber(7),
                int64.fromNumber(6),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(125),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-10T07:00:00Z' as timestamp,
          entryEnd: '2022-08-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(184),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(141),
                int64.fromNumber(18),
                int64.fromNumber(10),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(11),
                int64.fromNumber(14),
                int64.fromNumber(5),
                int64.fromNumber(10),
                int64.fromNumber(6),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(8),
                int64.fromNumber(8),
                int64.fromNumber(6),
                int64.fromNumber(6),
                int64.fromNumber(6),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(141),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-11T07:00:00Z' as timestamp,
          entryEnd: '2022-08-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(117),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(98),
                int64.fromNumber(14),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(6),
                int64.fromNumber(7),
                int64.fromNumber(3),
                int64.fromNumber(10),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(6),
                int64.fromNumber(9),
                int64.fromNumber(8),
                int64.fromNumber(9),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(98),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-12T07:00:00Z' as timestamp,
          entryEnd: '2022-08-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(114),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(87),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(7),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(6),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(5),
                int64.fromNumber(1),
                int64.fromNumber(4),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(87),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-13T07:00:00Z' as timestamp,
          entryEnd: '2022-08-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(24),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(18),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-14T07:00:00Z' as timestamp,
          entryEnd: '2022-08-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(43),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(28),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-15T07:00:00Z' as timestamp,
          entryEnd: '2022-08-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(179),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(139),
                int64.fromNumber(17),
                int64.fromNumber(14),
                int64.fromNumber(10),
                int64.fromNumber(9),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(7),
                int64.fromNumber(9),
                int64.fromNumber(7),
                int64.fromNumber(9),
                int64.fromNumber(6),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(139),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-16T07:00:00Z' as timestamp,
          entryEnd: '2022-08-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(171),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(133),
                int64.fromNumber(16),
                int64.fromNumber(12),
                int64.fromNumber(8),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(6),
                int64.fromNumber(8),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(5),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(133),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-17T07:00:00Z' as timestamp,
          entryEnd: '2022-08-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(155),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(122),
                int64.fromNumber(15),
                int64.fromNumber(10),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(11),
                int64.fromNumber(13),
                int64.fromNumber(9),
                int64.fromNumber(4),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(122),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-18T07:00:00Z' as timestamp,
          entryEnd: '2022-08-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(135),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(99),
                int64.fromNumber(6),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(8),
                int64.fromNumber(3),
                int64.fromNumber(6),
                int64.fromNumber(11),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(99),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-19T07:00:00Z' as timestamp,
          entryEnd: '2022-08-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(104),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(78),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(78),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(22),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(16),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(43),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(30),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(152),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(112),
                int64.fromNumber(14),
                int64.fromNumber(8),
                int64.fromNumber(11),
                int64.fromNumber(5),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(112),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(130),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(92),
                int64.fromNumber(8),
                int64.fromNumber(7),
                int64.fromNumber(5),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(92),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(99),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(84), int64.fromNumber(7), int64.fromNumber(5)],
              eventCounts: [
                {
                  count: int64.fromNumber(84),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(116),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(81), int64.fromNumber(9)],
              eventCounts: [
                {
                  count: int64.fromNumber(81),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(66),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(51)],
              eventCounts: [
                {
                  count: int64.fromNumber(51),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'Canada',
          fallback: false,
        },
      ],
      id: '69c10ddc-438f-419b-a65d-9d4d5180a372',
    },
    {
      cohort: [
        {
          entryStart: '2022-05-29T07:00:00Z' as timestamp,
          entryEnd: '2022-05-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-30T07:00:00Z' as timestamp,
          entryEnd: '2022-05-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-31T07:00:00Z' as timestamp,
          entryEnd: '2022-06-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-01T07:00:00Z' as timestamp,
          entryEnd: '2022-06-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-02T07:00:00Z' as timestamp,
          entryEnd: '2022-06-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-03T07:00:00Z' as timestamp,
          entryEnd: '2022-06-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-04T07:00:00Z' as timestamp,
          entryEnd: '2022-06-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-05T07:00:00Z' as timestamp,
          entryEnd: '2022-06-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-06T07:00:00Z' as timestamp,
          entryEnd: '2022-06-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-07T07:00:00Z' as timestamp,
          entryEnd: '2022-06-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-08T07:00:00Z' as timestamp,
          entryEnd: '2022-06-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-09T07:00:00Z' as timestamp,
          entryEnd: '2022-06-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-10T07:00:00Z' as timestamp,
          entryEnd: '2022-06-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-11T07:00:00Z' as timestamp,
          entryEnd: '2022-06-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-12T07:00:00Z' as timestamp,
          entryEnd: '2022-06-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-13T07:00:00Z' as timestamp,
          entryEnd: '2022-06-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-14T07:00:00Z' as timestamp,
          entryEnd: '2022-06-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-15T07:00:00Z' as timestamp,
          entryEnd: '2022-06-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-16T07:00:00Z' as timestamp,
          entryEnd: '2022-06-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-17T07:00:00Z' as timestamp,
          entryEnd: '2022-06-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-18T07:00:00Z' as timestamp,
          entryEnd: '2022-06-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-19T07:00:00Z' as timestamp,
          entryEnd: '2022-06-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-20T07:00:00Z' as timestamp,
          entryEnd: '2022-06-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-21T07:00:00Z' as timestamp,
          entryEnd: '2022-06-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-22T07:00:00Z' as timestamp,
          entryEnd: '2022-06-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-23T07:00:00Z' as timestamp,
          entryEnd: '2022-06-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-24T07:00:00Z' as timestamp,
          entryEnd: '2022-06-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-25T07:00:00Z' as timestamp,
          entryEnd: '2022-06-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-26T07:00:00Z' as timestamp,
          entryEnd: '2022-06-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-27T07:00:00Z' as timestamp,
          entryEnd: '2022-06-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-28T07:00:00Z' as timestamp,
          entryEnd: '2022-06-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-29T07:00:00Z' as timestamp,
          entryEnd: '2022-06-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-01T07:00:00Z' as timestamp,
          entryEnd: '2022-07-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-02T07:00:00Z' as timestamp,
          entryEnd: '2022-07-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-03T07:00:00Z' as timestamp,
          entryEnd: '2022-07-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-04T07:00:00Z' as timestamp,
          entryEnd: '2022-07-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-05T07:00:00Z' as timestamp,
          entryEnd: '2022-07-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-06T07:00:00Z' as timestamp,
          entryEnd: '2022-07-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-07T07:00:00Z' as timestamp,
          entryEnd: '2022-07-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-08T07:00:00Z' as timestamp,
          entryEnd: '2022-07-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-09T07:00:00Z' as timestamp,
          entryEnd: '2022-07-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-10T07:00:00Z' as timestamp,
          entryEnd: '2022-07-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-11T07:00:00Z' as timestamp,
          entryEnd: '2022-07-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-12T07:00:00Z' as timestamp,
          entryEnd: '2022-07-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-13T07:00:00Z' as timestamp,
          entryEnd: '2022-07-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-14T07:00:00Z' as timestamp,
          entryEnd: '2022-07-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-15T07:00:00Z' as timestamp,
          entryEnd: '2022-07-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-16T07:00:00Z' as timestamp,
          entryEnd: '2022-07-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-17T07:00:00Z' as timestamp,
          entryEnd: '2022-07-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-18T07:00:00Z' as timestamp,
          entryEnd: '2022-07-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-19T07:00:00Z' as timestamp,
          entryEnd: '2022-07-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-20T07:00:00Z' as timestamp,
          entryEnd: '2022-07-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-21T07:00:00Z' as timestamp,
          entryEnd: '2022-07-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-22T07:00:00Z' as timestamp,
          entryEnd: '2022-07-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-23T07:00:00Z' as timestamp,
          entryEnd: '2022-07-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-24T07:00:00Z' as timestamp,
          entryEnd: '2022-07-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-25T07:00:00Z' as timestamp,
          entryEnd: '2022-07-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-26T07:00:00Z' as timestamp,
          entryEnd: '2022-07-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-27T07:00:00Z' as timestamp,
          entryEnd: '2022-07-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(3),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-28T07:00:00Z' as timestamp,
          entryEnd: '2022-07-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(381),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(348),
                int64.fromNumber(128),
                int64.fromNumber(8),
                int64.fromNumber(14),
                int64.fromNumber(131),
                int64.fromNumber(117),
                int64.fromNumber(126),
                int64.fromNumber(124),
                int64.fromNumber(101),
                int64.fromNumber(14),
                int64.fromNumber(23),
                int64.fromNumber(106),
                int64.fromNumber(115),
                int64.fromNumber(108),
                int64.fromNumber(116),
                int64.fromNumber(92),
                int64.fromNumber(9),
                int64.fromNumber(14),
                int64.fromNumber(106),
                int64.fromNumber(118),
                int64.fromNumber(111),
                int64.fromNumber(116),
                int64.fromNumber(97),
                int64.fromNumber(12),
                int64.fromNumber(21),
                int64.fromNumber(106),
                int64.fromNumber(98),
                int64.fromNumber(106),
                int64.fromNumber(100),
                int64.fromNumber(88),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(348),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(128),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(131),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(117),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(126),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(124),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(101),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(106),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(115),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(108),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(116),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(92),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(106),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(118),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(111),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(116),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(97),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(106),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(98),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(106),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(100),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(88),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-29T07:00:00Z' as timestamp,
          entryEnd: '2022-07-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(207),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(185),
                int64.fromNumber(6),
                int64.fromNumber(6),
                int64.fromNumber(48),
                int64.fromNumber(40),
                int64.fromNumber(39),
                int64.fromNumber(35),
                int64.fromNumber(40),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(34),
                int64.fromNumber(36),
                int64.fromNumber(34),
                int64.fromNumber(37),
                int64.fromNumber(25),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(25),
                int64.fromNumber(37),
                int64.fromNumber(30),
                int64.fromNumber(30),
                int64.fromNumber(34),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(28),
                int64.fromNumber(37),
                int64.fromNumber(27),
                int64.fromNumber(31),
                int64.fromNumber(25),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(185),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(48),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(40),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(39),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(40),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(36),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(16),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(12),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-31T07:00:00Z' as timestamp,
          entryEnd: '2022-08-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(28),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(23),
                int64.fromNumber(7),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(5),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-01T07:00:00Z' as timestamp,
          entryEnd: '2022-08-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(233),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(212),
                int64.fromNumber(44),
                int64.fromNumber(31),
                int64.fromNumber(31),
                int64.fromNumber(31),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(25),
                int64.fromNumber(29),
                int64.fromNumber(27),
                int64.fromNumber(27),
                int64.fromNumber(21),
                int64.fromNumber(2),
                int64.fromNumber(4),
                int64.fromNumber(34),
                int64.fromNumber(39),
                int64.fromNumber(25),
                int64.fromNumber(35),
                int64.fromNumber(23),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(37),
                int64.fromNumber(25),
                int64.fromNumber(24),
                int64.fromNumber(27),
                int64.fromNumber(23),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(212),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(44),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(39),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-02T07:00:00Z' as timestamp,
          entryEnd: '2022-08-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(181),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(162),
                int64.fromNumber(28),
                int64.fromNumber(29),
                int64.fromNumber(32),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(27),
                int64.fromNumber(26),
                int64.fromNumber(21),
                int64.fromNumber(23),
                int64.fromNumber(17),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(18),
                int64.fromNumber(12),
                int64.fromNumber(21),
                int64.fromNumber(14),
                int64.fromNumber(10),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(21),
                int64.fromNumber(19),
                int64.fromNumber(20),
                int64.fromNumber(13),
                int64.fromNumber(14),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(162),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-03T07:00:00Z' as timestamp,
          entryEnd: '2022-08-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(139),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(117),
                int64.fromNumber(28),
                int64.fromNumber(13),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(19),
                int64.fromNumber(18),
                int64.fromNumber(16),
                int64.fromNumber(13),
                int64.fromNumber(9),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(15),
                int64.fromNumber(15),
                int64.fromNumber(15),
                int64.fromNumber(12),
                int64.fromNumber(12),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(11),
                int64.fromNumber(13),
                int64.fromNumber(14),
                int64.fromNumber(7),
                int64.fromNumber(10),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(117),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-04T07:00:00Z' as timestamp,
          entryEnd: '2022-08-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(185),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(144),
                int64.fromNumber(15),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(19),
                int64.fromNumber(24),
                int64.fromNumber(18),
                int64.fromNumber(15),
                int64.fromNumber(11),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(13),
                int64.fromNumber(12),
                int64.fromNumber(11),
                int64.fromNumber(11),
                int64.fromNumber(8),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(12),
                int64.fromNumber(12),
                int64.fromNumber(10),
                int64.fromNumber(10),
                int64.fromNumber(9),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(144),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-05T07:00:00Z' as timestamp,
          entryEnd: '2022-08-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(131),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(104),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(14),
                int64.fromNumber(13),
                int64.fromNumber(10),
                int64.fromNumber(11),
                int64.fromNumber(5),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(7),
                int64.fromNumber(10),
                int64.fromNumber(5),
                int64.fromNumber(8),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(6),
                int64.fromNumber(7),
                int64.fromNumber(4),
                int64.fromNumber(8),
                int64.fromNumber(6),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(104),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-06T07:00:00Z' as timestamp,
          entryEnd: '2022-08-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(10),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(5),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-07T07:00:00Z' as timestamp,
          entryEnd: '2022-08-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(26),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(19),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-08T07:00:00Z' as timestamp,
          entryEnd: '2022-08-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(154),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(128),
                int64.fromNumber(27),
                int64.fromNumber(21),
                int64.fromNumber(16),
                int64.fromNumber(13),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(19),
                int64.fromNumber(16),
                int64.fromNumber(18),
                int64.fromNumber(14),
                int64.fromNumber(6),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(10),
                int64.fromNumber(10),
                int64.fromNumber(12),
                int64.fromNumber(10),
                int64.fromNumber(7),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(128),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-09T07:00:00Z' as timestamp,
          entryEnd: '2022-08-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(134),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(107),
                int64.fromNumber(15),
                int64.fromNumber(13),
                int64.fromNumber(8),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(13),
                int64.fromNumber(16),
                int64.fromNumber(13),
                int64.fromNumber(7),
                int64.fromNumber(10),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(11),
                int64.fromNumber(12),
                int64.fromNumber(6),
                int64.fromNumber(10),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(107),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-10T07:00:00Z' as timestamp,
          entryEnd: '2022-08-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(89),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(75),
                int64.fromNumber(12),
                int64.fromNumber(7),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(10),
                int64.fromNumber(10),
                int64.fromNumber(7),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(6),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(75),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-11T07:00:00Z' as timestamp,
          entryEnd: '2022-08-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(116),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(91),
                int64.fromNumber(10),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(5),
                int64.fromNumber(12),
                int64.fromNumber(3),
                int64.fromNumber(6),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(5),
                int64.fromNumber(7),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(91),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-12T07:00:00Z' as timestamp,
          entryEnd: '2022-08-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(83),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(64),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(9),
                int64.fromNumber(7),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(4),
                int64.fromNumber(5),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(64),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-13T07:00:00Z' as timestamp,
          entryEnd: '2022-08-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(9),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(6),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-14T07:00:00Z' as timestamp,
          entryEnd: '2022-08-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(23),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(17),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-15T07:00:00Z' as timestamp,
          entryEnd: '2022-08-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(122),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(109),
                int64.fromNumber(19),
                int64.fromNumber(14),
                int64.fromNumber(9),
                int64.fromNumber(9),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(10),
                int64.fromNumber(11),
                int64.fromNumber(8),
                int64.fromNumber(10),
                int64.fromNumber(8),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(109),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-16T07:00:00Z' as timestamp,
          entryEnd: '2022-08-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(119),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(88),
                int64.fromNumber(12),
                int64.fromNumber(9),
                int64.fromNumber(8),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(9),
                int64.fromNumber(7),
                int64.fromNumber(9),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(88),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-17T07:00:00Z' as timestamp,
          entryEnd: '2022-08-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(107),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(92),
                int64.fromNumber(8),
                int64.fromNumber(5),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(92),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-18T07:00:00Z' as timestamp,
          entryEnd: '2022-08-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(108),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(92),
                int64.fromNumber(6),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(8),
                int64.fromNumber(3),
                int64.fromNumber(10),
                int64.fromNumber(4),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(92),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-19T07:00:00Z' as timestamp,
          entryEnd: '2022-08-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(53),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(44),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(44),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(9),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(8),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(12),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(10),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(123),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(104),
                int64.fromNumber(12),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(5),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(104),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(79),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(58),
                int64.fromNumber(9),
                int64.fromNumber(7),
                int64.fromNumber(7),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(58),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(89),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(68), int64.fromNumber(9), int64.fromNumber(7)],
              eventCounts: [
                {
                  count: int64.fromNumber(68),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(79),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(63), int64.fromNumber(9)],
              eventCounts: [
                {
                  count: int64.fromNumber(63),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(68),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(52)],
              eventCounts: [
                {
                  count: int64.fromNumber(52),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'United Kingdom',
          fallback: false,
        },
      ],
      id: '892e33c4-bfff-49b1-bb4a-6783d5d78736',
    },
    {
      cohort: [
        {
          entryStart: '2022-05-29T07:00:00Z' as timestamp,
          entryEnd: '2022-05-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-30T07:00:00Z' as timestamp,
          entryEnd: '2022-05-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-31T07:00:00Z' as timestamp,
          entryEnd: '2022-06-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-01T07:00:00Z' as timestamp,
          entryEnd: '2022-06-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-02T07:00:00Z' as timestamp,
          entryEnd: '2022-06-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-03T07:00:00Z' as timestamp,
          entryEnd: '2022-06-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-04T07:00:00Z' as timestamp,
          entryEnd: '2022-06-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-05T07:00:00Z' as timestamp,
          entryEnd: '2022-06-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-06T07:00:00Z' as timestamp,
          entryEnd: '2022-06-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-07T07:00:00Z' as timestamp,
          entryEnd: '2022-06-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-08T07:00:00Z' as timestamp,
          entryEnd: '2022-06-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-09T07:00:00Z' as timestamp,
          entryEnd: '2022-06-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-10T07:00:00Z' as timestamp,
          entryEnd: '2022-06-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-11T07:00:00Z' as timestamp,
          entryEnd: '2022-06-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-12T07:00:00Z' as timestamp,
          entryEnd: '2022-06-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-13T07:00:00Z' as timestamp,
          entryEnd: '2022-06-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-14T07:00:00Z' as timestamp,
          entryEnd: '2022-06-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-15T07:00:00Z' as timestamp,
          entryEnd: '2022-06-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-16T07:00:00Z' as timestamp,
          entryEnd: '2022-06-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-17T07:00:00Z' as timestamp,
          entryEnd: '2022-06-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-18T07:00:00Z' as timestamp,
          entryEnd: '2022-06-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-19T07:00:00Z' as timestamp,
          entryEnd: '2022-06-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-20T07:00:00Z' as timestamp,
          entryEnd: '2022-06-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-21T07:00:00Z' as timestamp,
          entryEnd: '2022-06-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-22T07:00:00Z' as timestamp,
          entryEnd: '2022-06-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-23T07:00:00Z' as timestamp,
          entryEnd: '2022-06-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-24T07:00:00Z' as timestamp,
          entryEnd: '2022-06-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-25T07:00:00Z' as timestamp,
          entryEnd: '2022-06-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-26T07:00:00Z' as timestamp,
          entryEnd: '2022-06-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-27T07:00:00Z' as timestamp,
          entryEnd: '2022-06-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-28T07:00:00Z' as timestamp,
          entryEnd: '2022-06-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-29T07:00:00Z' as timestamp,
          entryEnd: '2022-06-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-01T07:00:00Z' as timestamp,
          entryEnd: '2022-07-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-02T07:00:00Z' as timestamp,
          entryEnd: '2022-07-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-03T07:00:00Z' as timestamp,
          entryEnd: '2022-07-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-04T07:00:00Z' as timestamp,
          entryEnd: '2022-07-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-05T07:00:00Z' as timestamp,
          entryEnd: '2022-07-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-06T07:00:00Z' as timestamp,
          entryEnd: '2022-07-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-07T07:00:00Z' as timestamp,
          entryEnd: '2022-07-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-08T07:00:00Z' as timestamp,
          entryEnd: '2022-07-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-09T07:00:00Z' as timestamp,
          entryEnd: '2022-07-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-10T07:00:00Z' as timestamp,
          entryEnd: '2022-07-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-11T07:00:00Z' as timestamp,
          entryEnd: '2022-07-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-12T07:00:00Z' as timestamp,
          entryEnd: '2022-07-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-13T07:00:00Z' as timestamp,
          entryEnd: '2022-07-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-14T07:00:00Z' as timestamp,
          entryEnd: '2022-07-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-15T07:00:00Z' as timestamp,
          entryEnd: '2022-07-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-16T07:00:00Z' as timestamp,
          entryEnd: '2022-07-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-17T07:00:00Z' as timestamp,
          entryEnd: '2022-07-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-18T07:00:00Z' as timestamp,
          entryEnd: '2022-07-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-19T07:00:00Z' as timestamp,
          entryEnd: '2022-07-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-20T07:00:00Z' as timestamp,
          entryEnd: '2022-07-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-21T07:00:00Z' as timestamp,
          entryEnd: '2022-07-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-22T07:00:00Z' as timestamp,
          entryEnd: '2022-07-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-23T07:00:00Z' as timestamp,
          entryEnd: '2022-07-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-24T07:00:00Z' as timestamp,
          entryEnd: '2022-07-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-25T07:00:00Z' as timestamp,
          entryEnd: '2022-07-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-26T07:00:00Z' as timestamp,
          entryEnd: '2022-07-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-27T07:00:00Z' as timestamp,
          entryEnd: '2022-07-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(23),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(22),
                int64.fromNumber(20),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(14),
                int64.fromNumber(14),
                int64.fromNumber(10),
                int64.fromNumber(12),
                int64.fromNumber(13),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(9),
                int64.fromNumber(11),
                int64.fromNumber(9),
                int64.fromNumber(9),
                int64.fromNumber(9),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(7),
                int64.fromNumber(12),
                int64.fromNumber(11),
                int64.fromNumber(11),
                int64.fromNumber(9),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(8),
                int64.fromNumber(6),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-28T07:00:00Z' as timestamp,
          entryEnd: '2022-07-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(271),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(235),
                int64.fromNumber(22),
                int64.fromNumber(12),
                int64.fromNumber(75),
                int64.fromNumber(69),
                int64.fromNumber(70),
                int64.fromNumber(69),
                int64.fromNumber(74),
                int64.fromNumber(13),
                int64.fromNumber(5),
                int64.fromNumber(51),
                int64.fromNumber(71),
                int64.fromNumber(48),
                int64.fromNumber(64),
                int64.fromNumber(62),
                int64.fromNumber(14),
                int64.fromNumber(3),
                int64.fromNumber(63),
                int64.fromNumber(65),
                int64.fromNumber(60),
                int64.fromNumber(69),
                int64.fromNumber(60),
                int64.fromNumber(16),
                int64.fromNumber(3),
                int64.fromNumber(53),
                int64.fromNumber(42),
                int64.fromNumber(46),
                int64.fromNumber(44),
                int64.fromNumber(53),
                int64.fromNumber(9),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(235),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(75),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(69),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(70),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(69),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(74),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(51),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(71),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(48),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(64),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(62),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(63),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(65),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(60),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(69),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(60),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(53),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(42),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(44),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(53),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-29T07:00:00Z' as timestamp,
          entryEnd: '2022-07-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(36),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(25),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(5),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(24),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(18),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-31T07:00:00Z' as timestamp,
          entryEnd: '2022-08-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(213),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(186),
                int64.fromNumber(45),
                int64.fromNumber(41),
                int64.fromNumber(35),
                int64.fromNumber(45),
                int64.fromNumber(7),
                int64.fromNumber(1),
                int64.fromNumber(40),
                int64.fromNumber(32),
                int64.fromNumber(31),
                int64.fromNumber(28),
                int64.fromNumber(32),
                int64.fromNumber(4),
                int64.fromNumber(1),
                int64.fromNumber(25),
                int64.fromNumber(34),
                int64.fromNumber(32),
                int64.fromNumber(26),
                int64.fromNumber(19),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(32),
                int64.fromNumber(31),
                int64.fromNumber(28),
                int64.fromNumber(36),
                int64.fromNumber(27),
                int64.fromNumber(4),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(186),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(45),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(41),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(45),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(40),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(36),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-01T07:00:00Z' as timestamp,
          entryEnd: '2022-08-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(207),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(171),
                int64.fromNumber(36),
                int64.fromNumber(28),
                int64.fromNumber(24),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(25),
                int64.fromNumber(33),
                int64.fromNumber(22),
                int64.fromNumber(25),
                int64.fromNumber(20),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(23),
                int64.fromNumber(32),
                int64.fromNumber(23),
                int64.fromNumber(18),
                int64.fromNumber(15),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(18),
                int64.fromNumber(23),
                int64.fromNumber(20),
                int64.fromNumber(23),
                int64.fromNumber(21),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(171),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(36),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-02T07:00:00Z' as timestamp,
          entryEnd: '2022-08-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(179),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(149),
                int64.fromNumber(28),
                int64.fromNumber(22),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(17),
                int64.fromNumber(17),
                int64.fromNumber(16),
                int64.fromNumber(18),
                int64.fromNumber(12),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(11),
                int64.fromNumber(14),
                int64.fromNumber(12),
                int64.fromNumber(19),
                int64.fromNumber(13),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(19),
                int64.fromNumber(21),
                int64.fromNumber(15),
                int64.fromNumber(17),
                int64.fromNumber(15),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(149),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-03T07:00:00Z' as timestamp,
          entryEnd: '2022-08-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(152),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(119),
                int64.fromNumber(22),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(15),
                int64.fromNumber(17),
                int64.fromNumber(12),
                int64.fromNumber(12),
                int64.fromNumber(10),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(10),
                int64.fromNumber(11),
                int64.fromNumber(10),
                int64.fromNumber(11),
                int64.fromNumber(8),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(7),
                int64.fromNumber(14),
                int64.fromNumber(7),
                int64.fromNumber(11),
                int64.fromNumber(9),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(119),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-04T07:00:00Z' as timestamp,
          entryEnd: '2022-08-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(134),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(111),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(9),
                int64.fromNumber(11),
                int64.fromNumber(8),
                int64.fromNumber(4),
                int64.fromNumber(7),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(7),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(10),
                int64.fromNumber(5),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(111),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-05T07:00:00Z' as timestamp,
          entryEnd: '2022-08-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(27),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(19),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-06T07:00:00Z' as timestamp,
          entryEnd: '2022-08-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(23),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(17),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-07T07:00:00Z' as timestamp,
          entryEnd: '2022-08-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(120),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(94),
                int64.fromNumber(22),
                int64.fromNumber(10),
                int64.fromNumber(11),
                int64.fromNumber(12),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(9),
                int64.fromNumber(8),
                int64.fromNumber(9),
                int64.fromNumber(10),
                int64.fromNumber(10),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(8),
                int64.fromNumber(10),
                int64.fromNumber(6),
                int64.fromNumber(8),
                int64.fromNumber(5),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(94),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-08T07:00:00Z' as timestamp,
          entryEnd: '2022-08-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(132),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(108),
                int64.fromNumber(7),
                int64.fromNumber(12),
                int64.fromNumber(10),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(7),
                int64.fromNumber(12),
                int64.fromNumber(10),
                int64.fromNumber(16),
                int64.fromNumber(11),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(5),
                int64.fromNumber(10),
                int64.fromNumber(10),
                int64.fromNumber(7),
                int64.fromNumber(8),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(108),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-09T07:00:00Z' as timestamp,
          entryEnd: '2022-08-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(145),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(104),
                int64.fromNumber(17),
                int64.fromNumber(8),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(7),
                int64.fromNumber(7),
                int64.fromNumber(10),
                int64.fromNumber(6),
                int64.fromNumber(8),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(6),
                int64.fromNumber(6),
                int64.fromNumber(8),
                int64.fromNumber(10),
                int64.fromNumber(11),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(104),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-10T07:00:00Z' as timestamp,
          entryEnd: '2022-08-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(115),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(89),
                int64.fromNumber(15),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(7),
                int64.fromNumber(4),
                int64.fromNumber(6),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(89),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-11T07:00:00Z' as timestamp,
          entryEnd: '2022-08-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(93),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(70),
                int64.fromNumber(6),
                int64.fromNumber(1),
                int64.fromNumber(7),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(6),
                int64.fromNumber(4),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(70),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-12T07:00:00Z' as timestamp,
          entryEnd: '2022-08-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(32),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(23),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-13T07:00:00Z' as timestamp,
          entryEnd: '2022-08-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(24),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(13),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-14T07:00:00Z' as timestamp,
          entryEnd: '2022-08-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(109),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(90),
                int64.fromNumber(12),
                int64.fromNumber(7),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(7),
                int64.fromNumber(9),
                int64.fromNumber(10),
                int64.fromNumber(6),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(90),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-15T07:00:00Z' as timestamp,
          entryEnd: '2022-08-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(114),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(90),
                int64.fromNumber(16),
                int64.fromNumber(11),
                int64.fromNumber(6),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(6),
                int64.fromNumber(4),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(90),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-16T07:00:00Z' as timestamp,
          entryEnd: '2022-08-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(109),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(85),
                int64.fromNumber(10),
                int64.fromNumber(7),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(7),
                int64.fromNumber(4),
                int64.fromNumber(6),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(85),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-17T07:00:00Z' as timestamp,
          entryEnd: '2022-08-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(107),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(87),
                int64.fromNumber(12),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(8),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(87),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-18T07:00:00Z' as timestamp,
          entryEnd: '2022-08-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(101),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(83),
                int64.fromNumber(5),
                int64.fromNumber(0),
                int64.fromNumber(12),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(83),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-19T07:00:00Z' as timestamp,
          entryEnd: '2022-08-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(27),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(18),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(20),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(10),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(92),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(67),
                int64.fromNumber(10),
                int64.fromNumber(6),
                int64.fromNumber(10),
                int64.fromNumber(7),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(67),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(94),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(78),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(1),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(78),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(89),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(71),
                int64.fromNumber(14),
                int64.fromNumber(5),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(71),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(115),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(87), int64.fromNumber(12), int64.fromNumber(3)],
              eventCounts: [
                {
                  count: int64.fromNumber(87),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(98),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(72), int64.fromNumber(2)],
              eventCounts: [
                {
                  count: int64.fromNumber(72),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(15),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(10)],
              eventCounts: [
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'Australia',
          fallback: false,
        },
      ],
      id: '9ef524ff-af2d-46c9-a120-77b2d9463e80',
    },
    {
      cohort: [
        {
          entryStart: '2022-05-29T07:00:00Z' as timestamp,
          entryEnd: '2022-05-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-30T07:00:00Z' as timestamp,
          entryEnd: '2022-05-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-31T07:00:00Z' as timestamp,
          entryEnd: '2022-06-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-01T07:00:00Z' as timestamp,
          entryEnd: '2022-06-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-02T07:00:00Z' as timestamp,
          entryEnd: '2022-06-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-03T07:00:00Z' as timestamp,
          entryEnd: '2022-06-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-04T07:00:00Z' as timestamp,
          entryEnd: '2022-06-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-05T07:00:00Z' as timestamp,
          entryEnd: '2022-06-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-06T07:00:00Z' as timestamp,
          entryEnd: '2022-06-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-07T07:00:00Z' as timestamp,
          entryEnd: '2022-06-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-08T07:00:00Z' as timestamp,
          entryEnd: '2022-06-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-09T07:00:00Z' as timestamp,
          entryEnd: '2022-06-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-10T07:00:00Z' as timestamp,
          entryEnd: '2022-06-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-11T07:00:00Z' as timestamp,
          entryEnd: '2022-06-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-12T07:00:00Z' as timestamp,
          entryEnd: '2022-06-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-13T07:00:00Z' as timestamp,
          entryEnd: '2022-06-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-14T07:00:00Z' as timestamp,
          entryEnd: '2022-06-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-15T07:00:00Z' as timestamp,
          entryEnd: '2022-06-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-16T07:00:00Z' as timestamp,
          entryEnd: '2022-06-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-17T07:00:00Z' as timestamp,
          entryEnd: '2022-06-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-18T07:00:00Z' as timestamp,
          entryEnd: '2022-06-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-19T07:00:00Z' as timestamp,
          entryEnd: '2022-06-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-20T07:00:00Z' as timestamp,
          entryEnd: '2022-06-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-21T07:00:00Z' as timestamp,
          entryEnd: '2022-06-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-22T07:00:00Z' as timestamp,
          entryEnd: '2022-06-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-23T07:00:00Z' as timestamp,
          entryEnd: '2022-06-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-24T07:00:00Z' as timestamp,
          entryEnd: '2022-06-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-25T07:00:00Z' as timestamp,
          entryEnd: '2022-06-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-26T07:00:00Z' as timestamp,
          entryEnd: '2022-06-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-27T07:00:00Z' as timestamp,
          entryEnd: '2022-06-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-28T07:00:00Z' as timestamp,
          entryEnd: '2022-06-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-29T07:00:00Z' as timestamp,
          entryEnd: '2022-06-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-01T07:00:00Z' as timestamp,
          entryEnd: '2022-07-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-02T07:00:00Z' as timestamp,
          entryEnd: '2022-07-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-03T07:00:00Z' as timestamp,
          entryEnd: '2022-07-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-04T07:00:00Z' as timestamp,
          entryEnd: '2022-07-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-05T07:00:00Z' as timestamp,
          entryEnd: '2022-07-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-06T07:00:00Z' as timestamp,
          entryEnd: '2022-07-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-07T07:00:00Z' as timestamp,
          entryEnd: '2022-07-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-08T07:00:00Z' as timestamp,
          entryEnd: '2022-07-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-09T07:00:00Z' as timestamp,
          entryEnd: '2022-07-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-10T07:00:00Z' as timestamp,
          entryEnd: '2022-07-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-11T07:00:00Z' as timestamp,
          entryEnd: '2022-07-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-12T07:00:00Z' as timestamp,
          entryEnd: '2022-07-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-13T07:00:00Z' as timestamp,
          entryEnd: '2022-07-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-14T07:00:00Z' as timestamp,
          entryEnd: '2022-07-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-15T07:00:00Z' as timestamp,
          entryEnd: '2022-07-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-16T07:00:00Z' as timestamp,
          entryEnd: '2022-07-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-17T07:00:00Z' as timestamp,
          entryEnd: '2022-07-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-18T07:00:00Z' as timestamp,
          entryEnd: '2022-07-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-19T07:00:00Z' as timestamp,
          entryEnd: '2022-07-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-20T07:00:00Z' as timestamp,
          entryEnd: '2022-07-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-21T07:00:00Z' as timestamp,
          entryEnd: '2022-07-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-22T07:00:00Z' as timestamp,
          entryEnd: '2022-07-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-23T07:00:00Z' as timestamp,
          entryEnd: '2022-07-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-24T07:00:00Z' as timestamp,
          entryEnd: '2022-07-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-25T07:00:00Z' as timestamp,
          entryEnd: '2022-07-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-26T07:00:00Z' as timestamp,
          entryEnd: '2022-07-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-27T07:00:00Z' as timestamp,
          entryEnd: '2022-07-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(152),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(148),
                int64.fromNumber(151),
                int64.fromNumber(123),
                int64.fromNumber(100),
                int64.fromNumber(99),
                int64.fromNumber(84),
                int64.fromNumber(80),
                int64.fromNumber(66),
                int64.fromNumber(58),
                int64.fromNumber(48),
                int64.fromNumber(41),
                int64.fromNumber(33),
                int64.fromNumber(29),
                int64.fromNumber(25),
                int64.fromNumber(18),
                int64.fromNumber(15),
                int64.fromNumber(12),
                int64.fromNumber(9),
                int64.fromNumber(9),
                int64.fromNumber(7),
                int64.fromNumber(6),
                int64.fromNumber(8),
                int64.fromNumber(6),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(148),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(151),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(123),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(100),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(99),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(84),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(80),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(66),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(58),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(48),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(41),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-28T07:00:00Z' as timestamp,
          entryEnd: '2022-07-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(373),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(361),
                int64.fromNumber(253),
                int64.fromNumber(190),
                int64.fromNumber(199),
                int64.fromNumber(198),
                int64.fromNumber(171),
                int64.fromNumber(135),
                int64.fromNumber(126),
                int64.fromNumber(107),
                int64.fromNumber(76),
                int64.fromNumber(77),
                int64.fromNumber(68),
                int64.fromNumber(56),
                int64.fromNumber(46),
                int64.fromNumber(35),
                int64.fromNumber(17),
                int64.fromNumber(9),
                int64.fromNumber(16),
                int64.fromNumber(16),
                int64.fromNumber(16),
                int64.fromNumber(24),
                int64.fromNumber(16),
                int64.fromNumber(8),
                int64.fromNumber(6),
                int64.fromNumber(7),
                int64.fromNumber(10),
                int64.fromNumber(18),
                int64.fromNumber(11),
                int64.fromNumber(9),
                int64.fromNumber(8),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(361),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(253),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(190),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(199),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(198),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(171),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(135),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(126),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(107),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(76),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(77),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(68),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(56),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-29T07:00:00Z' as timestamp,
          entryEnd: '2022-07-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(96),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(93),
                int64.fromNumber(52),
                int64.fromNumber(50),
                int64.fromNumber(47),
                int64.fromNumber(42),
                int64.fromNumber(38),
                int64.fromNumber(35),
                int64.fromNumber(30),
                int64.fromNumber(26),
                int64.fromNumber(23),
                int64.fromNumber(22),
                int64.fromNumber(25),
                int64.fromNumber(20),
                int64.fromNumber(16),
                int64.fromNumber(16),
                int64.fromNumber(7),
                int64.fromNumber(6),
                int64.fromNumber(7),
                int64.fromNumber(3),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(93),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(52),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(50),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(47),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(42),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(65),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(60),
                int64.fromNumber(35),
                int64.fromNumber(32),
                int64.fromNumber(26),
                int64.fromNumber(21),
                int64.fromNumber(17),
                int64.fromNumber(14),
                int64.fromNumber(13),
                int64.fromNumber(9),
                int64.fromNumber(7),
                int64.fromNumber(9),
                int64.fromNumber(7),
                int64.fromNumber(6),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(60),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-31T07:00:00Z' as timestamp,
          entryEnd: '2022-08-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(113),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(108),
                int64.fromNumber(61),
                int64.fromNumber(54),
                int64.fromNumber(49),
                int64.fromNumber(33),
                int64.fromNumber(25),
                int64.fromNumber(20),
                int64.fromNumber(20),
                int64.fromNumber(29),
                int64.fromNumber(27),
                int64.fromNumber(20),
                int64.fromNumber(21),
                int64.fromNumber(19),
                int64.fromNumber(15),
                int64.fromNumber(15),
                int64.fromNumber(10),
                int64.fromNumber(8),
                int64.fromNumber(12),
                int64.fromNumber(10),
                int64.fromNumber(10),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(6),
                int64.fromNumber(8),
                int64.fromNumber(8),
                int64.fromNumber(8),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(108),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(61),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(54),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(49),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-01T07:00:00Z' as timestamp,
          entryEnd: '2022-08-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(119),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(112),
                int64.fromNumber(68),
                int64.fromNumber(52),
                int64.fromNumber(47),
                int64.fromNumber(50),
                int64.fromNumber(31),
                int64.fromNumber(30),
                int64.fromNumber(29),
                int64.fromNumber(31),
                int64.fromNumber(27),
                int64.fromNumber(21),
                int64.fromNumber(19),
                int64.fromNumber(14),
                int64.fromNumber(20),
                int64.fromNumber(17),
                int64.fromNumber(12),
                int64.fromNumber(13),
                int64.fromNumber(10),
                int64.fromNumber(4),
                int64.fromNumber(6),
                int64.fromNumber(7),
                int64.fromNumber(10),
                int64.fromNumber(7),
                int64.fromNumber(5),
                int64.fromNumber(10),
                int64.fromNumber(4),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(112),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(68),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(52),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(47),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(50),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-02T07:00:00Z' as timestamp,
          entryEnd: '2022-08-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(131),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(123),
                int64.fromNumber(77),
                int64.fromNumber(63),
                int64.fromNumber(53),
                int64.fromNumber(42),
                int64.fromNumber(44),
                int64.fromNumber(40),
                int64.fromNumber(41),
                int64.fromNumber(40),
                int64.fromNumber(31),
                int64.fromNumber(27),
                int64.fromNumber(28),
                int64.fromNumber(26),
                int64.fromNumber(23),
                int64.fromNumber(19),
                int64.fromNumber(16),
                int64.fromNumber(10),
                int64.fromNumber(6),
                int64.fromNumber(6),
                int64.fromNumber(6),
                int64.fromNumber(7),
                int64.fromNumber(10),
                int64.fromNumber(7),
                int64.fromNumber(8),
                int64.fromNumber(4),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(123),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(77),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(63),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(53),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(42),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(44),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(40),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(41),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(40),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-03T07:00:00Z' as timestamp,
          entryEnd: '2022-08-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(127),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(117),
                int64.fromNumber(73),
                int64.fromNumber(64),
                int64.fromNumber(48),
                int64.fromNumber(49),
                int64.fromNumber(38),
                int64.fromNumber(33),
                int64.fromNumber(29),
                int64.fromNumber(31),
                int64.fromNumber(23),
                int64.fromNumber(21),
                int64.fromNumber(22),
                int64.fromNumber(17),
                int64.fromNumber(10),
                int64.fromNumber(15),
                int64.fromNumber(9),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(6),
                int64.fromNumber(4),
                int64.fromNumber(7),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(117),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(73),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(64),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(48),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(49),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-04T07:00:00Z' as timestamp,
          entryEnd: '2022-08-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(100),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(94),
                int64.fromNumber(56),
                int64.fromNumber(46),
                int64.fromNumber(41),
                int64.fromNumber(36),
                int64.fromNumber(30),
                int64.fromNumber(29),
                int64.fromNumber(27),
                int64.fromNumber(28),
                int64.fromNumber(19),
                int64.fromNumber(20),
                int64.fromNumber(21),
                int64.fromNumber(21),
                int64.fromNumber(21),
                int64.fromNumber(15),
                int64.fromNumber(9),
                int64.fromNumber(8),
                int64.fromNumber(4),
                int64.fromNumber(8),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(94),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(56),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(41),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(36),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-05T07:00:00Z' as timestamp,
          entryEnd: '2022-08-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(92),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(86),
                int64.fromNumber(50),
                int64.fromNumber(43),
                int64.fromNumber(39),
                int64.fromNumber(35),
                int64.fromNumber(35),
                int64.fromNumber(29),
                int64.fromNumber(25),
                int64.fromNumber(18),
                int64.fromNumber(21),
                int64.fromNumber(20),
                int64.fromNumber(15),
                int64.fromNumber(19),
                int64.fromNumber(16),
                int64.fromNumber(15),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(7),
                int64.fromNumber(6),
                int64.fromNumber(7),
                int64.fromNumber(4),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(86),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(50),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(43),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(39),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-06T07:00:00Z' as timestamp,
          entryEnd: '2022-08-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(78),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(75),
                int64.fromNumber(50),
                int64.fromNumber(41),
                int64.fromNumber(38),
                int64.fromNumber(30),
                int64.fromNumber(32),
                int64.fromNumber(25),
                int64.fromNumber(19),
                int64.fromNumber(18),
                int64.fromNumber(21),
                int64.fromNumber(19),
                int64.fromNumber(16),
                int64.fromNumber(16),
                int64.fromNumber(11),
                int64.fromNumber(12),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(75),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(50),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(41),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-07T07:00:00Z' as timestamp,
          entryEnd: '2022-08-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(78),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(74),
                int64.fromNumber(54),
                int64.fromNumber(40),
                int64.fromNumber(34),
                int64.fromNumber(34),
                int64.fromNumber(27),
                int64.fromNumber(17),
                int64.fromNumber(23),
                int64.fromNumber(23),
                int64.fromNumber(17),
                int64.fromNumber(16),
                int64.fromNumber(18),
                int64.fromNumber(14),
                int64.fromNumber(10),
                int64.fromNumber(14),
                int64.fromNumber(8),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(5),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(74),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(54),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(40),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-08T07:00:00Z' as timestamp,
          entryEnd: '2022-08-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(109),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(103),
                int64.fromNumber(72),
                int64.fromNumber(67),
                int64.fromNumber(53),
                int64.fromNumber(48),
                int64.fromNumber(38),
                int64.fromNumber(40),
                int64.fromNumber(37),
                int64.fromNumber(32),
                int64.fromNumber(32),
                int64.fromNumber(34),
                int64.fromNumber(28),
                int64.fromNumber(21),
                int64.fromNumber(26),
                int64.fromNumber(24),
                int64.fromNumber(15),
                int64.fromNumber(8),
                int64.fromNumber(13),
                int64.fromNumber(5),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(103),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(72),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(67),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(53),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(48),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(40),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-09T07:00:00Z' as timestamp,
          entryEnd: '2022-08-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(78),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(72),
                int64.fromNumber(44),
                int64.fromNumber(42),
                int64.fromNumber(33),
                int64.fromNumber(27),
                int64.fromNumber(29),
                int64.fromNumber(31),
                int64.fromNumber(21),
                int64.fromNumber(25),
                int64.fromNumber(24),
                int64.fromNumber(18),
                int64.fromNumber(18),
                int64.fromNumber(18),
                int64.fromNumber(20),
                int64.fromNumber(18),
                int64.fromNumber(12),
                int64.fromNumber(7),
                int64.fromNumber(5),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(72),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(44),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(42),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-10T07:00:00Z' as timestamp,
          entryEnd: '2022-08-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(103),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(95),
                int64.fromNumber(55),
                int64.fromNumber(46),
                int64.fromNumber(31),
                int64.fromNumber(30),
                int64.fromNumber(32),
                int64.fromNumber(29),
                int64.fromNumber(24),
                int64.fromNumber(25),
                int64.fromNumber(20),
                int64.fromNumber(18),
                int64.fromNumber(16),
                int64.fromNumber(16),
                int64.fromNumber(17),
                int64.fromNumber(12),
                int64.fromNumber(9),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(95),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(55),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-11T07:00:00Z' as timestamp,
          entryEnd: '2022-08-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(73),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(64),
                int64.fromNumber(38),
                int64.fromNumber(28),
                int64.fromNumber(28),
                int64.fromNumber(28),
                int64.fromNumber(21),
                int64.fromNumber(19),
                int64.fromNumber(18),
                int64.fromNumber(19),
                int64.fromNumber(18),
                int64.fromNumber(18),
                int64.fromNumber(19),
                int64.fromNumber(20),
                int64.fromNumber(19),
                int64.fromNumber(15),
                int64.fromNumber(4),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(64),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-12T07:00:00Z' as timestamp,
          entryEnd: '2022-08-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(74),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(67),
                int64.fromNumber(38),
                int64.fromNumber(33),
                int64.fromNumber(30),
                int64.fromNumber(28),
                int64.fromNumber(26),
                int64.fromNumber(27),
                int64.fromNumber(19),
                int64.fromNumber(14),
                int64.fromNumber(13),
                int64.fromNumber(18),
                int64.fromNumber(17),
                int64.fromNumber(14),
                int64.fromNumber(12),
                int64.fromNumber(8),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(67),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-13T07:00:00Z' as timestamp,
          entryEnd: '2022-08-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(35),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(34),
                int64.fromNumber(20),
                int64.fromNumber(17),
                int64.fromNumber(15),
                int64.fromNumber(17),
                int64.fromNumber(13),
                int64.fromNumber(15),
                int64.fromNumber(13),
                int64.fromNumber(12),
                int64.fromNumber(10),
                int64.fromNumber(11),
                int64.fromNumber(12),
                int64.fromNumber(12),
                int64.fromNumber(10),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-14T07:00:00Z' as timestamp,
          entryEnd: '2022-08-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(66),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(62),
                int64.fromNumber(37),
                int64.fromNumber(32),
                int64.fromNumber(26),
                int64.fromNumber(23),
                int64.fromNumber(18),
                int64.fromNumber(16),
                int64.fromNumber(15),
                int64.fromNumber(14),
                int64.fromNumber(14),
                int64.fromNumber(16),
                int64.fromNumber(13),
                int64.fromNumber(14),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(62),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-15T07:00:00Z' as timestamp,
          entryEnd: '2022-08-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(71),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(69),
                int64.fromNumber(51),
                int64.fromNumber(46),
                int64.fromNumber(38),
                int64.fromNumber(37),
                int64.fromNumber(31),
                int64.fromNumber(27),
                int64.fromNumber(28),
                int64.fromNumber(27),
                int64.fromNumber(30),
                int64.fromNumber(26),
                int64.fromNumber(15),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(69),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(51),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-16T07:00:00Z' as timestamp,
          entryEnd: '2022-08-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(75),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(68),
                int64.fromNumber(45),
                int64.fromNumber(37),
                int64.fromNumber(32),
                int64.fromNumber(26),
                int64.fromNumber(26),
                int64.fromNumber(30),
                int64.fromNumber(28),
                int64.fromNumber(25),
                int64.fromNumber(25),
                int64.fromNumber(20),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(68),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(45),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-17T07:00:00Z' as timestamp,
          entryEnd: '2022-08-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(87),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(83),
                int64.fromNumber(55),
                int64.fromNumber(47),
                int64.fromNumber(34),
                int64.fromNumber(38),
                int64.fromNumber(35),
                int64.fromNumber(30),
                int64.fromNumber(29),
                int64.fromNumber(27),
                int64.fromNumber(17),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(83),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(55),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(47),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-18T07:00:00Z' as timestamp,
          entryEnd: '2022-08-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(77),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(72),
                int64.fromNumber(54),
                int64.fromNumber(45),
                int64.fromNumber(38),
                int64.fromNumber(35),
                int64.fromNumber(31),
                int64.fromNumber(32),
                int64.fromNumber(26),
                int64.fromNumber(18),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(72),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(54),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(45),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-19T07:00:00Z' as timestamp,
          entryEnd: '2022-08-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(48),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(43),
                int64.fromNumber(26),
                int64.fromNumber(21),
                int64.fromNumber(19),
                int64.fromNumber(18),
                int64.fromNumber(15),
                int64.fromNumber(13),
                int64.fromNumber(7),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(43),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(57),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(54),
                int64.fromNumber(33),
                int64.fromNumber(29),
                int64.fromNumber(27),
                int64.fromNumber(19),
                int64.fromNumber(16),
                int64.fromNumber(15),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(54),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(58),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(53),
                int64.fromNumber(32),
                int64.fromNumber(28),
                int64.fromNumber(27),
                int64.fromNumber(21),
                int64.fromNumber(15),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(53),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(79),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(74),
                int64.fromNumber(51),
                int64.fromNumber(48),
                int64.fromNumber(42),
                int64.fromNumber(32),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(74),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(51),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(48),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(42),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(122),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(117),
                int64.fromNumber(68),
                int64.fromNumber(63),
                int64.fromNumber(52),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(117),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(68),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(63),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(52),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(87),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(82), int64.fromNumber(61), int64.fromNumber(43)],
              eventCounts: [
                {
                  count: int64.fromNumber(82),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(61),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(43),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(92),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(85), int64.fromNumber(54)],
              eventCounts: [
                {
                  count: int64.fromNumber(85),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(54),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(33),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(30)],
              eventCounts: [
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'Viet Nam',
          fallback: false,
        },
      ],
      id: '176fcce0-5198-4490-83c9-714bcf3680ae',
    },
    {
      cohort: [
        {
          entryStart: '2022-05-29T07:00:00Z' as timestamp,
          entryEnd: '2022-05-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-30T07:00:00Z' as timestamp,
          entryEnd: '2022-05-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-31T07:00:00Z' as timestamp,
          entryEnd: '2022-06-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-01T07:00:00Z' as timestamp,
          entryEnd: '2022-06-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-02T07:00:00Z' as timestamp,
          entryEnd: '2022-06-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-03T07:00:00Z' as timestamp,
          entryEnd: '2022-06-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-04T07:00:00Z' as timestamp,
          entryEnd: '2022-06-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-05T07:00:00Z' as timestamp,
          entryEnd: '2022-06-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-06T07:00:00Z' as timestamp,
          entryEnd: '2022-06-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-07T07:00:00Z' as timestamp,
          entryEnd: '2022-06-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-08T07:00:00Z' as timestamp,
          entryEnd: '2022-06-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-09T07:00:00Z' as timestamp,
          entryEnd: '2022-06-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-10T07:00:00Z' as timestamp,
          entryEnd: '2022-06-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-11T07:00:00Z' as timestamp,
          entryEnd: '2022-06-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-12T07:00:00Z' as timestamp,
          entryEnd: '2022-06-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-13T07:00:00Z' as timestamp,
          entryEnd: '2022-06-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-14T07:00:00Z' as timestamp,
          entryEnd: '2022-06-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-15T07:00:00Z' as timestamp,
          entryEnd: '2022-06-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-16T07:00:00Z' as timestamp,
          entryEnd: '2022-06-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-17T07:00:00Z' as timestamp,
          entryEnd: '2022-06-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-18T07:00:00Z' as timestamp,
          entryEnd: '2022-06-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-19T07:00:00Z' as timestamp,
          entryEnd: '2022-06-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-20T07:00:00Z' as timestamp,
          entryEnd: '2022-06-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-21T07:00:00Z' as timestamp,
          entryEnd: '2022-06-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-22T07:00:00Z' as timestamp,
          entryEnd: '2022-06-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-23T07:00:00Z' as timestamp,
          entryEnd: '2022-06-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-24T07:00:00Z' as timestamp,
          entryEnd: '2022-06-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-25T07:00:00Z' as timestamp,
          entryEnd: '2022-06-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-26T07:00:00Z' as timestamp,
          entryEnd: '2022-06-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-27T07:00:00Z' as timestamp,
          entryEnd: '2022-06-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-28T07:00:00Z' as timestamp,
          entryEnd: '2022-06-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-29T07:00:00Z' as timestamp,
          entryEnd: '2022-06-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-01T07:00:00Z' as timestamp,
          entryEnd: '2022-07-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-02T07:00:00Z' as timestamp,
          entryEnd: '2022-07-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-03T07:00:00Z' as timestamp,
          entryEnd: '2022-07-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-04T07:00:00Z' as timestamp,
          entryEnd: '2022-07-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-05T07:00:00Z' as timestamp,
          entryEnd: '2022-07-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-06T07:00:00Z' as timestamp,
          entryEnd: '2022-07-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-07T07:00:00Z' as timestamp,
          entryEnd: '2022-07-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-08T07:00:00Z' as timestamp,
          entryEnd: '2022-07-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-09T07:00:00Z' as timestamp,
          entryEnd: '2022-07-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-10T07:00:00Z' as timestamp,
          entryEnd: '2022-07-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-11T07:00:00Z' as timestamp,
          entryEnd: '2022-07-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-12T07:00:00Z' as timestamp,
          entryEnd: '2022-07-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-13T07:00:00Z' as timestamp,
          entryEnd: '2022-07-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-14T07:00:00Z' as timestamp,
          entryEnd: '2022-07-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-15T07:00:00Z' as timestamp,
          entryEnd: '2022-07-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-16T07:00:00Z' as timestamp,
          entryEnd: '2022-07-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-17T07:00:00Z' as timestamp,
          entryEnd: '2022-07-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-18T07:00:00Z' as timestamp,
          entryEnd: '2022-07-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-19T07:00:00Z' as timestamp,
          entryEnd: '2022-07-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-20T07:00:00Z' as timestamp,
          entryEnd: '2022-07-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-21T07:00:00Z' as timestamp,
          entryEnd: '2022-07-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-22T07:00:00Z' as timestamp,
          entryEnd: '2022-07-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-23T07:00:00Z' as timestamp,
          entryEnd: '2022-07-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-24T07:00:00Z' as timestamp,
          entryEnd: '2022-07-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-25T07:00:00Z' as timestamp,
          entryEnd: '2022-07-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-26T07:00:00Z' as timestamp,
          entryEnd: '2022-07-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-27T07:00:00Z' as timestamp,
          entryEnd: '2022-07-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(32),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(29),
                int64.fromNumber(25),
                int64.fromNumber(4),
                int64.fromNumber(8),
                int64.fromNumber(19),
                int64.fromNumber(19),
                int64.fromNumber(15),
                int64.fromNumber(17),
                int64.fromNumber(14),
                int64.fromNumber(3),
                int64.fromNumber(5),
                int64.fromNumber(15),
                int64.fromNumber(16),
                int64.fromNumber(17),
                int64.fromNumber(17),
                int64.fromNumber(14),
                int64.fromNumber(2),
                int64.fromNumber(9),
                int64.fromNumber(15),
                int64.fromNumber(15),
                int64.fromNumber(13),
                int64.fromNumber(12),
                int64.fromNumber(8),
                int64.fromNumber(4),
                int64.fromNumber(7),
                int64.fromNumber(10),
                int64.fromNumber(9),
                int64.fromNumber(12),
                int64.fromNumber(14),
                int64.fromNumber(10),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-28T07:00:00Z' as timestamp,
          entryEnd: '2022-07-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(380),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(340),
                int64.fromNumber(38),
                int64.fromNumber(39),
                int64.fromNumber(123),
                int64.fromNumber(135),
                int64.fromNumber(119),
                int64.fromNumber(109),
                int64.fromNumber(108),
                int64.fromNumber(20),
                int64.fromNumber(29),
                int64.fromNumber(115),
                int64.fromNumber(112),
                int64.fromNumber(105),
                int64.fromNumber(99),
                int64.fromNumber(90),
                int64.fromNumber(25),
                int64.fromNumber(33),
                int64.fromNumber(93),
                int64.fromNumber(97),
                int64.fromNumber(95),
                int64.fromNumber(98),
                int64.fromNumber(85),
                int64.fromNumber(25),
                int64.fromNumber(24),
                int64.fromNumber(75),
                int64.fromNumber(86),
                int64.fromNumber(88),
                int64.fromNumber(94),
                int64.fromNumber(65),
                int64.fromNumber(17),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(340),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(39),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(123),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(135),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(119),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(109),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(108),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(115),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(112),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(105),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(99),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(90),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(93),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(97),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(95),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(98),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(85),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(75),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(86),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(88),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(94),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(65),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-29T07:00:00Z' as timestamp,
          entryEnd: '2022-07-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(33),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(27),
                int64.fromNumber(3),
                int64.fromNumber(5),
                int64.fromNumber(8),
                int64.fromNumber(8),
                int64.fromNumber(5),
                int64.fromNumber(6),
                int64.fromNumber(6),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(6),
                int64.fromNumber(12),
                int64.fromNumber(9),
                int64.fromNumber(8),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(7),
                int64.fromNumber(6),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(38),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(34),
                int64.fromNumber(17),
                int64.fromNumber(14),
                int64.fromNumber(15),
                int64.fromNumber(9),
                int64.fromNumber(14),
                int64.fromNumber(2),
                int64.fromNumber(9),
                int64.fromNumber(12),
                int64.fromNumber(11),
                int64.fromNumber(11),
                int64.fromNumber(9),
                int64.fromNumber(8),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(7),
                int64.fromNumber(10),
                int64.fromNumber(7),
                int64.fromNumber(7),
                int64.fromNumber(7),
                int64.fromNumber(2),
                int64.fromNumber(6),
                int64.fromNumber(10),
                int64.fromNumber(8),
                int64.fromNumber(10),
                int64.fromNumber(9),
                int64.fromNumber(6),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-31T07:00:00Z' as timestamp,
          entryEnd: '2022-08-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(206),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(187),
                int64.fromNumber(61),
                int64.fromNumber(48),
                int64.fromNumber(50),
                int64.fromNumber(41),
                int64.fromNumber(7),
                int64.fromNumber(7),
                int64.fromNumber(46),
                int64.fromNumber(51),
                int64.fromNumber(54),
                int64.fromNumber(39),
                int64.fromNumber(29),
                int64.fromNumber(9),
                int64.fromNumber(12),
                int64.fromNumber(35),
                int64.fromNumber(40),
                int64.fromNumber(31),
                int64.fromNumber(38),
                int64.fromNumber(35),
                int64.fromNumber(6),
                int64.fromNumber(10),
                int64.fromNumber(37),
                int64.fromNumber(33),
                int64.fromNumber(25),
                int64.fromNumber(30),
                int64.fromNumber(26),
                int64.fromNumber(5),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(187),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(61),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(48),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(50),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(41),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(51),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(54),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(39),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(40),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-01T07:00:00Z' as timestamp,
          entryEnd: '2022-08-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(211),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(182),
                int64.fromNumber(44),
                int64.fromNumber(37),
                int64.fromNumber(30),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(28),
                int64.fromNumber(39),
                int64.fromNumber(32),
                int64.fromNumber(30),
                int64.fromNumber(23),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(16),
                int64.fromNumber(29),
                int64.fromNumber(28),
                int64.fromNumber(30),
                int64.fromNumber(16),
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(18),
                int64.fromNumber(22),
                int64.fromNumber(26),
                int64.fromNumber(26),
                int64.fromNumber(25),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(182),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(44),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(39),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-02T07:00:00Z' as timestamp,
          entryEnd: '2022-08-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(179),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(163),
                int64.fromNumber(26),
                int64.fromNumber(27),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(19),
                int64.fromNumber(26),
                int64.fromNumber(21),
                int64.fromNumber(23),
                int64.fromNumber(17),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(17),
                int64.fromNumber(17),
                int64.fromNumber(13),
                int64.fromNumber(12),
                int64.fromNumber(10),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(14),
                int64.fromNumber(10),
                int64.fromNumber(19),
                int64.fromNumber(15),
                int64.fromNumber(9),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(163),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-03T07:00:00Z' as timestamp,
          entryEnd: '2022-08-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(148),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(136),
                int64.fromNumber(20),
                int64.fromNumber(0),
                int64.fromNumber(5),
                int64.fromNumber(27),
                int64.fromNumber(27),
                int64.fromNumber(20),
                int64.fromNumber(20),
                int64.fromNumber(17),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(18),
                int64.fromNumber(15),
                int64.fromNumber(21),
                int64.fromNumber(8),
                int64.fromNumber(12),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(8),
                int64.fromNumber(6),
                int64.fromNumber(11),
                int64.fromNumber(10),
                int64.fromNumber(6),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(136),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-04T07:00:00Z' as timestamp,
          entryEnd: '2022-08-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(103),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(87),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(12),
                int64.fromNumber(13),
                int64.fromNumber(9),
                int64.fromNumber(4),
                int64.fromNumber(14),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(8),
                int64.fromNumber(4),
                int64.fromNumber(7),
                int64.fromNumber(8),
                int64.fromNumber(7),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(8),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(8),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(87),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-05T07:00:00Z' as timestamp,
          entryEnd: '2022-08-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(27),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(21),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-06T07:00:00Z' as timestamp,
          entryEnd: '2022-08-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(20),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(15),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-07T07:00:00Z' as timestamp,
          entryEnd: '2022-08-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(87),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(73),
                int64.fromNumber(19),
                int64.fromNumber(16),
                int64.fromNumber(12),
                int64.fromNumber(9),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(19),
                int64.fromNumber(11),
                int64.fromNumber(9),
                int64.fromNumber(9),
                int64.fromNumber(11),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(10),
                int64.fromNumber(9),
                int64.fromNumber(11),
                int64.fromNumber(9),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(73),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-08T07:00:00Z' as timestamp,
          entryEnd: '2022-08-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(143),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(121),
                int64.fromNumber(25),
                int64.fromNumber(19),
                int64.fromNumber(12),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(15),
                int64.fromNumber(17),
                int64.fromNumber(13),
                int64.fromNumber(13),
                int64.fromNumber(9),
                int64.fromNumber(2),
                int64.fromNumber(5),
                int64.fromNumber(13),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(10),
                int64.fromNumber(12),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(121),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-09T07:00:00Z' as timestamp,
          entryEnd: '2022-08-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(108),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(85),
                int64.fromNumber(16),
                int64.fromNumber(10),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(12),
                int64.fromNumber(7),
                int64.fromNumber(9),
                int64.fromNumber(14),
                int64.fromNumber(9),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(12),
                int64.fromNumber(6),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(85),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(16),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-10T07:00:00Z' as timestamp,
          entryEnd: '2022-08-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(89),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(80),
                int64.fromNumber(6),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(7),
                int64.fromNumber(6),
                int64.fromNumber(10),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(80),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-11T07:00:00Z' as timestamp,
          entryEnd: '2022-08-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(71),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(60),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(4),
                int64.fromNumber(6),
                int64.fromNumber(10),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(60),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-12T07:00:00Z' as timestamp,
          entryEnd: '2022-08-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(18),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(17),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-13T07:00:00Z' as timestamp,
          entryEnd: '2022-08-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(14),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(8),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-14T07:00:00Z' as timestamp,
          entryEnd: '2022-08-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(93),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(76),
                int64.fromNumber(10),
                int64.fromNumber(5),
                int64.fromNumber(6),
                int64.fromNumber(7),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(7),
                int64.fromNumber(11),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(7),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(76),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-15T07:00:00Z' as timestamp,
          entryEnd: '2022-08-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(84),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(74),
                int64.fromNumber(8),
                int64.fromNumber(5),
                int64.fromNumber(7),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(6),
                int64.fromNumber(8),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(10),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(74),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-16T07:00:00Z' as timestamp,
          entryEnd: '2022-08-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(72),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(56),
                int64.fromNumber(10),
                int64.fromNumber(9),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(7),
                int64.fromNumber(8),
                int64.fromNumber(3),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(56),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-17T07:00:00Z' as timestamp,
          entryEnd: '2022-08-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(88),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(70),
                int64.fromNumber(11),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(7),
                int64.fromNumber(7),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(70),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-18T07:00:00Z' as timestamp,
          entryEnd: '2022-08-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(50),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(38),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(7),
                int64.fromNumber(3),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-19T07:00:00Z' as timestamp,
          entryEnd: '2022-08-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(17),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(14),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(17),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(13),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(67),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(56),
                int64.fromNumber(8),
                int64.fromNumber(8),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(56),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(67),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(49),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(6),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(49),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(55),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(44),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(44),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(54),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(44), int64.fromNumber(7), int64.fromNumber(0)],
              eventCounts: [
                {
                  count: int64.fromNumber(44),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(41),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(33), int64.fromNumber(2)],
              eventCounts: [
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(8),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(5)],
              eventCounts: [
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'Israel',
          fallback: false,
        },
      ],
      id: '1f115054-2ff3-45d1-956c-7da169f67353',
    },
    {
      cohort: [
        {
          entryStart: '2022-05-29T07:00:00Z' as timestamp,
          entryEnd: '2022-05-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-30T07:00:00Z' as timestamp,
          entryEnd: '2022-05-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-31T07:00:00Z' as timestamp,
          entryEnd: '2022-06-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-01T07:00:00Z' as timestamp,
          entryEnd: '2022-06-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-02T07:00:00Z' as timestamp,
          entryEnd: '2022-06-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-03T07:00:00Z' as timestamp,
          entryEnd: '2022-06-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-04T07:00:00Z' as timestamp,
          entryEnd: '2022-06-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-05T07:00:00Z' as timestamp,
          entryEnd: '2022-06-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-06T07:00:00Z' as timestamp,
          entryEnd: '2022-06-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-07T07:00:00Z' as timestamp,
          entryEnd: '2022-06-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-08T07:00:00Z' as timestamp,
          entryEnd: '2022-06-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-09T07:00:00Z' as timestamp,
          entryEnd: '2022-06-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-10T07:00:00Z' as timestamp,
          entryEnd: '2022-06-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-11T07:00:00Z' as timestamp,
          entryEnd: '2022-06-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-12T07:00:00Z' as timestamp,
          entryEnd: '2022-06-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-13T07:00:00Z' as timestamp,
          entryEnd: '2022-06-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-14T07:00:00Z' as timestamp,
          entryEnd: '2022-06-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-15T07:00:00Z' as timestamp,
          entryEnd: '2022-06-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-16T07:00:00Z' as timestamp,
          entryEnd: '2022-06-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-17T07:00:00Z' as timestamp,
          entryEnd: '2022-06-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-18T07:00:00Z' as timestamp,
          entryEnd: '2022-06-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-19T07:00:00Z' as timestamp,
          entryEnd: '2022-06-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-20T07:00:00Z' as timestamp,
          entryEnd: '2022-06-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-21T07:00:00Z' as timestamp,
          entryEnd: '2022-06-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-22T07:00:00Z' as timestamp,
          entryEnd: '2022-06-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-23T07:00:00Z' as timestamp,
          entryEnd: '2022-06-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-24T07:00:00Z' as timestamp,
          entryEnd: '2022-06-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-25T07:00:00Z' as timestamp,
          entryEnd: '2022-06-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-26T07:00:00Z' as timestamp,
          entryEnd: '2022-06-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-27T07:00:00Z' as timestamp,
          entryEnd: '2022-06-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-28T07:00:00Z' as timestamp,
          entryEnd: '2022-06-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-29T07:00:00Z' as timestamp,
          entryEnd: '2022-06-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-01T07:00:00Z' as timestamp,
          entryEnd: '2022-07-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-02T07:00:00Z' as timestamp,
          entryEnd: '2022-07-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-03T07:00:00Z' as timestamp,
          entryEnd: '2022-07-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-04T07:00:00Z' as timestamp,
          entryEnd: '2022-07-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-05T07:00:00Z' as timestamp,
          entryEnd: '2022-07-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-06T07:00:00Z' as timestamp,
          entryEnd: '2022-07-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-07T07:00:00Z' as timestamp,
          entryEnd: '2022-07-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-08T07:00:00Z' as timestamp,
          entryEnd: '2022-07-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-09T07:00:00Z' as timestamp,
          entryEnd: '2022-07-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-10T07:00:00Z' as timestamp,
          entryEnd: '2022-07-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-11T07:00:00Z' as timestamp,
          entryEnd: '2022-07-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-12T07:00:00Z' as timestamp,
          entryEnd: '2022-07-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-13T07:00:00Z' as timestamp,
          entryEnd: '2022-07-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-14T07:00:00Z' as timestamp,
          entryEnd: '2022-07-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-15T07:00:00Z' as timestamp,
          entryEnd: '2022-07-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-16T07:00:00Z' as timestamp,
          entryEnd: '2022-07-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-17T07:00:00Z' as timestamp,
          entryEnd: '2022-07-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-18T07:00:00Z' as timestamp,
          entryEnd: '2022-07-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-19T07:00:00Z' as timestamp,
          entryEnd: '2022-07-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-20T07:00:00Z' as timestamp,
          entryEnd: '2022-07-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-21T07:00:00Z' as timestamp,
          entryEnd: '2022-07-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-22T07:00:00Z' as timestamp,
          entryEnd: '2022-07-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-23T07:00:00Z' as timestamp,
          entryEnd: '2022-07-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-24T07:00:00Z' as timestamp,
          entryEnd: '2022-07-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-25T07:00:00Z' as timestamp,
          entryEnd: '2022-07-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-26T07:00:00Z' as timestamp,
          entryEnd: '2022-07-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-27T07:00:00Z' as timestamp,
          entryEnd: '2022-07-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(7),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(7),
                int64.fromNumber(6),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(6),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(4),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-28T07:00:00Z' as timestamp,
          entryEnd: '2022-07-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(117),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(106),
                int64.fromNumber(36),
                int64.fromNumber(9),
                int64.fromNumber(26),
                int64.fromNumber(52),
                int64.fromNumber(53),
                int64.fromNumber(63),
                int64.fromNumber(58),
                int64.fromNumber(33),
                int64.fromNumber(9),
                int64.fromNumber(34),
                int64.fromNumber(51),
                int64.fromNumber(56),
                int64.fromNumber(50),
                int64.fromNumber(51),
                int64.fromNumber(32),
                int64.fromNumber(15),
                int64.fromNumber(34),
                int64.fromNumber(52),
                int64.fromNumber(48),
                int64.fromNumber(52),
                int64.fromNumber(50),
                int64.fromNumber(39),
                int64.fromNumber(12),
                int64.fromNumber(27),
                int64.fromNumber(46),
                int64.fromNumber(45),
                int64.fromNumber(59),
                int64.fromNumber(50),
                int64.fromNumber(24),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(106),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(36),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(52),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(53),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(63),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(58),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(51),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(56),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(50),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(51),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(52),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(48),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(52),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(50),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(39),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(45),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(59),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(50),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-29T07:00:00Z' as timestamp,
          entryEnd: '2022-07-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(52),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(42),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(12),
                int64.fromNumber(15),
                int64.fromNumber(10),
                int64.fromNumber(7),
                int64.fromNumber(8),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(9),
                int64.fromNumber(8),
                int64.fromNumber(7),
                int64.fromNumber(9),
                int64.fromNumber(9),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(9),
                int64.fromNumber(9),
                int64.fromNumber(8),
                int64.fromNumber(7),
                int64.fromNumber(7),
                int64.fromNumber(3),
                int64.fromNumber(6),
                int64.fromNumber(8),
                int64.fromNumber(11),
                int64.fromNumber(11),
                int64.fromNumber(5),
                int64.fromNumber(8),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(42),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(11),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(8),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-31T07:00:00Z' as timestamp,
          entryEnd: '2022-08-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(33),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(25),
                int64.fromNumber(5),
                int64.fromNumber(9),
                int64.fromNumber(9),
                int64.fromNumber(7),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(9),
                int64.fromNumber(4),
                int64.fromNumber(7),
                int64.fromNumber(7),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(8),
                int64.fromNumber(6),
                int64.fromNumber(7),
                int64.fromNumber(5),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-01T07:00:00Z' as timestamp,
          entryEnd: '2022-08-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(60),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(48),
                int64.fromNumber(14),
                int64.fromNumber(7),
                int64.fromNumber(10),
                int64.fromNumber(7),
                int64.fromNumber(0),
                int64.fromNumber(5),
                int64.fromNumber(9),
                int64.fromNumber(5),
                int64.fromNumber(8),
                int64.fromNumber(8),
                int64.fromNumber(4),
                int64.fromNumber(1),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(7),
                int64.fromNumber(7),
                int64.fromNumber(8),
                int64.fromNumber(2),
                int64.fromNumber(5),
                int64.fromNumber(7),
                int64.fromNumber(6),
                int64.fromNumber(7),
                int64.fromNumber(6),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(48),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-02T07:00:00Z' as timestamp,
          entryEnd: '2022-08-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(39),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(33),
                int64.fromNumber(6),
                int64.fromNumber(8),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(6),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(7),
                int64.fromNumber(7),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(33),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-03T07:00:00Z' as timestamp,
          entryEnd: '2022-08-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(46),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(34),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(6),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(6),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(5),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-04T07:00:00Z' as timestamp,
          entryEnd: '2022-08-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(41),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(25),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-05T07:00:00Z' as timestamp,
          entryEnd: '2022-08-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(24),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(17),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(6),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-06T07:00:00Z' as timestamp,
          entryEnd: '2022-08-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(20),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(15),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-07T07:00:00Z' as timestamp,
          entryEnd: '2022-08-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(22),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(18),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-08T07:00:00Z' as timestamp,
          entryEnd: '2022-08-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(40),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(22),
                int64.fromNumber(2),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-09T07:00:00Z' as timestamp,
          entryEnd: '2022-08-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(30),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(22),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-10T07:00:00Z' as timestamp,
          entryEnd: '2022-08-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(46),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(32),
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-11T07:00:00Z' as timestamp,
          entryEnd: '2022-08-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(38),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(27),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-12T07:00:00Z' as timestamp,
          entryEnd: '2022-08-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(36),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(20),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-13T07:00:00Z' as timestamp,
          entryEnd: '2022-08-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(14),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(9),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-14T07:00:00Z' as timestamp,
          entryEnd: '2022-08-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(25),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(15),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-15T07:00:00Z' as timestamp,
          entryEnd: '2022-08-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(30),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(24),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-16T07:00:00Z' as timestamp,
          entryEnd: '2022-08-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(46),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(31),
                int64.fromNumber(7),
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-17T07:00:00Z' as timestamp,
          entryEnd: '2022-08-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(51),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(36),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(36),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-18T07:00:00Z' as timestamp,
          entryEnd: '2022-08-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(45),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(25),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-19T07:00:00Z' as timestamp,
          entryEnd: '2022-08-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(30),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(22),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(20),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(11),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(32),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(20),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(81),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(49),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(49),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(86),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(56),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(56),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(80),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(49), int64.fromNumber(0), int64.fromNumber(4)],
              eventCounts: [
                {
                  count: int64.fromNumber(49),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(71),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(42), int64.fromNumber(1)],
              eventCounts: [
                {
                  count: int64.fromNumber(42),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(34),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(21)],
              eventCounts: [
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'Philippines',
          fallback: false,
        },
      ],
      id: 'de9a67d9-468a-4d11-8e44-7cd34501d7d8',
    },
    {
      cohort: [
        {
          entryStart: '2022-05-29T07:00:00Z' as timestamp,
          entryEnd: '2022-05-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-30T07:00:00Z' as timestamp,
          entryEnd: '2022-05-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-31T07:00:00Z' as timestamp,
          entryEnd: '2022-06-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-01T07:00:00Z' as timestamp,
          entryEnd: '2022-06-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-02T07:00:00Z' as timestamp,
          entryEnd: '2022-06-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-03T07:00:00Z' as timestamp,
          entryEnd: '2022-06-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-04T07:00:00Z' as timestamp,
          entryEnd: '2022-06-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-05T07:00:00Z' as timestamp,
          entryEnd: '2022-06-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-06T07:00:00Z' as timestamp,
          entryEnd: '2022-06-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-07T07:00:00Z' as timestamp,
          entryEnd: '2022-06-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-08T07:00:00Z' as timestamp,
          entryEnd: '2022-06-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-09T07:00:00Z' as timestamp,
          entryEnd: '2022-06-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-10T07:00:00Z' as timestamp,
          entryEnd: '2022-06-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-11T07:00:00Z' as timestamp,
          entryEnd: '2022-06-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-12T07:00:00Z' as timestamp,
          entryEnd: '2022-06-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-13T07:00:00Z' as timestamp,
          entryEnd: '2022-06-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-14T07:00:00Z' as timestamp,
          entryEnd: '2022-06-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-15T07:00:00Z' as timestamp,
          entryEnd: '2022-06-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-16T07:00:00Z' as timestamp,
          entryEnd: '2022-06-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-17T07:00:00Z' as timestamp,
          entryEnd: '2022-06-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-18T07:00:00Z' as timestamp,
          entryEnd: '2022-06-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-19T07:00:00Z' as timestamp,
          entryEnd: '2022-06-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-20T07:00:00Z' as timestamp,
          entryEnd: '2022-06-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-21T07:00:00Z' as timestamp,
          entryEnd: '2022-06-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-22T07:00:00Z' as timestamp,
          entryEnd: '2022-06-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-23T07:00:00Z' as timestamp,
          entryEnd: '2022-06-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-24T07:00:00Z' as timestamp,
          entryEnd: '2022-06-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-25T07:00:00Z' as timestamp,
          entryEnd: '2022-06-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-26T07:00:00Z' as timestamp,
          entryEnd: '2022-06-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-27T07:00:00Z' as timestamp,
          entryEnd: '2022-06-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-28T07:00:00Z' as timestamp,
          entryEnd: '2022-06-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-29T07:00:00Z' as timestamp,
          entryEnd: '2022-06-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-01T07:00:00Z' as timestamp,
          entryEnd: '2022-07-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-02T07:00:00Z' as timestamp,
          entryEnd: '2022-07-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-03T07:00:00Z' as timestamp,
          entryEnd: '2022-07-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-04T07:00:00Z' as timestamp,
          entryEnd: '2022-07-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-05T07:00:00Z' as timestamp,
          entryEnd: '2022-07-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-06T07:00:00Z' as timestamp,
          entryEnd: '2022-07-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-07T07:00:00Z' as timestamp,
          entryEnd: '2022-07-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-08T07:00:00Z' as timestamp,
          entryEnd: '2022-07-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-09T07:00:00Z' as timestamp,
          entryEnd: '2022-07-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-10T07:00:00Z' as timestamp,
          entryEnd: '2022-07-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-11T07:00:00Z' as timestamp,
          entryEnd: '2022-07-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-12T07:00:00Z' as timestamp,
          entryEnd: '2022-07-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-13T07:00:00Z' as timestamp,
          entryEnd: '2022-07-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-14T07:00:00Z' as timestamp,
          entryEnd: '2022-07-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-15T07:00:00Z' as timestamp,
          entryEnd: '2022-07-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-16T07:00:00Z' as timestamp,
          entryEnd: '2022-07-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-17T07:00:00Z' as timestamp,
          entryEnd: '2022-07-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-18T07:00:00Z' as timestamp,
          entryEnd: '2022-07-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-19T07:00:00Z' as timestamp,
          entryEnd: '2022-07-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-20T07:00:00Z' as timestamp,
          entryEnd: '2022-07-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-21T07:00:00Z' as timestamp,
          entryEnd: '2022-07-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-22T07:00:00Z' as timestamp,
          entryEnd: '2022-07-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-23T07:00:00Z' as timestamp,
          entryEnd: '2022-07-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-24T07:00:00Z' as timestamp,
          entryEnd: '2022-07-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-25T07:00:00Z' as timestamp,
          entryEnd: '2022-07-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-26T07:00:00Z' as timestamp,
          entryEnd: '2022-07-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-27T07:00:00Z' as timestamp,
          entryEnd: '2022-07-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-28T07:00:00Z' as timestamp,
          entryEnd: '2022-07-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(132),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(113),
                int64.fromNumber(36),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(32),
                int64.fromNumber(45),
                int64.fromNumber(41),
                int64.fromNumber(38),
                int64.fromNumber(25),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(34),
                int64.fromNumber(30),
                int64.fromNumber(19),
                int64.fromNumber(23),
                int64.fromNumber(28),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(26),
                int64.fromNumber(29),
                int64.fromNumber(35),
                int64.fromNumber(28),
                int64.fromNumber(29),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(27),
                int64.fromNumber(35),
                int64.fromNumber(20),
                int64.fromNumber(31),
                int64.fromNumber(28),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(113),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(36),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(45),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(41),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(25),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-29T07:00:00Z' as timestamp,
          entryEnd: '2022-07-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(59),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(50),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(15),
                int64.fromNumber(8),
                int64.fromNumber(14),
                int64.fromNumber(9),
                int64.fromNumber(9),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(9),
                int64.fromNumber(6),
                int64.fromNumber(10),
                int64.fromNumber(9),
                int64.fromNumber(9),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(10),
                int64.fromNumber(11),
                int64.fromNumber(11),
                int64.fromNumber(13),
                int64.fromNumber(7),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(8),
                int64.fromNumber(11),
                int64.fromNumber(10),
                int64.fromNumber(8),
                int64.fromNumber(12),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(50),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(5),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-31T07:00:00Z' as timestamp,
          entryEnd: '2022-08-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(7),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-01T07:00:00Z' as timestamp,
          entryEnd: '2022-08-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(79),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(67),
                int64.fromNumber(11),
                int64.fromNumber(13),
                int64.fromNumber(9),
                int64.fromNumber(11),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(9),
                int64.fromNumber(9),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(6),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(12),
                int64.fromNumber(9),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(8),
                int64.fromNumber(6),
                int64.fromNumber(7),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(67),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-02T07:00:00Z' as timestamp,
          entryEnd: '2022-08-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(62),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(50),
                int64.fromNumber(12),
                int64.fromNumber(10),
                int64.fromNumber(10),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(6),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(7),
                int64.fromNumber(5),
                int64.fromNumber(8),
                int64.fromNumber(5),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(8),
                int64.fromNumber(2),
                int64.fromNumber(12),
                int64.fromNumber(8),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(50),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-03T07:00:00Z' as timestamp,
          entryEnd: '2022-08-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(70),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(62),
                int64.fromNumber(13),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(8),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(7),
                int64.fromNumber(9),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(8),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(62),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-04T07:00:00Z' as timestamp,
          entryEnd: '2022-08-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(48),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(38),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(6),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(7),
                int64.fromNumber(2),
                int64.fromNumber(4),
                int64.fromNumber(6),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(4),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(38),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-05T07:00:00Z' as timestamp,
          entryEnd: '2022-08-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(48),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(37),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(8),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(6),
                int64.fromNumber(1),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-06T07:00:00Z' as timestamp,
          entryEnd: '2022-08-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(6),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(5),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-07T07:00:00Z' as timestamp,
          entryEnd: '2022-08-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(5),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-08T07:00:00Z' as timestamp,
          entryEnd: '2022-08-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(56),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(42),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(4),
                int64.fromNumber(4),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(42),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-09T07:00:00Z' as timestamp,
          entryEnd: '2022-08-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(56),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(40),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(4),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(40),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-10T07:00:00Z' as timestamp,
          entryEnd: '2022-08-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(51),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(46),
                int64.fromNumber(9),
                int64.fromNumber(5),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-11T07:00:00Z' as timestamp,
          entryEnd: '2022-08-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(37),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(31),
                int64.fromNumber(6),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(6),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(31),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-12T07:00:00Z' as timestamp,
          entryEnd: '2022-08-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(34),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(29),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(4),
                int64.fromNumber(6),
                int64.fromNumber(4),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-13T07:00:00Z' as timestamp,
          entryEnd: '2022-08-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(8),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(4),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-14T07:00:00Z' as timestamp,
          entryEnd: '2022-08-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(4),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-15T07:00:00Z' as timestamp,
          entryEnd: '2022-08-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(52),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(40),
                int64.fromNumber(7),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(40),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-16T07:00:00Z' as timestamp,
          entryEnd: '2022-08-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(51),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(43),
                int64.fromNumber(6),
                int64.fromNumber(7),
                int64.fromNumber(7),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(6),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(43),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-17T07:00:00Z' as timestamp,
          entryEnd: '2022-08-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(37),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(28),
                int64.fromNumber(5),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-18T07:00:00Z' as timestamp,
          entryEnd: '2022-08-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(47),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(35),
                int64.fromNumber(5),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(5),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(35),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-19T07:00:00Z' as timestamp,
          entryEnd: '2022-08-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(41),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(36),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(36),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(2),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(5),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(21),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(18),
                int64.fromNumber(2),
                int64.fromNumber(5),
                int64.fromNumber(1),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(48),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(39),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(39),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(37),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(24), int64.fromNumber(7), int64.fromNumber(2)],
              eventCounts: [
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(32),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(28), int64.fromNumber(0)],
              eventCounts: [
                {
                  count: int64.fromNumber(28),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(24),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(17)],
              eventCounts: [
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'Brazil',
          fallback: false,
        },
      ],
      id: '66a4fca5-d562-44c0-90d4-3ff139d42561',
    },
    {
      cohort: [
        {
          entryStart: '2022-05-29T07:00:00Z' as timestamp,
          entryEnd: '2022-05-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-30T07:00:00Z' as timestamp,
          entryEnd: '2022-05-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-05-31T07:00:00Z' as timestamp,
          entryEnd: '2022-06-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-01T07:00:00Z' as timestamp,
          entryEnd: '2022-06-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-02T07:00:00Z' as timestamp,
          entryEnd: '2022-06-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-03T07:00:00Z' as timestamp,
          entryEnd: '2022-06-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-04T07:00:00Z' as timestamp,
          entryEnd: '2022-06-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-05T07:00:00Z' as timestamp,
          entryEnd: '2022-06-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-06T07:00:00Z' as timestamp,
          entryEnd: '2022-06-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-07T07:00:00Z' as timestamp,
          entryEnd: '2022-06-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-08T07:00:00Z' as timestamp,
          entryEnd: '2022-06-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-09T07:00:00Z' as timestamp,
          entryEnd: '2022-06-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-10T07:00:00Z' as timestamp,
          entryEnd: '2022-06-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-11T07:00:00Z' as timestamp,
          entryEnd: '2022-06-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-12T07:00:00Z' as timestamp,
          entryEnd: '2022-06-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-13T07:00:00Z' as timestamp,
          entryEnd: '2022-06-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-14T07:00:00Z' as timestamp,
          entryEnd: '2022-06-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-15T07:00:00Z' as timestamp,
          entryEnd: '2022-06-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-16T07:00:00Z' as timestamp,
          entryEnd: '2022-06-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-17T07:00:00Z' as timestamp,
          entryEnd: '2022-06-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-18T07:00:00Z' as timestamp,
          entryEnd: '2022-06-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-19T07:00:00Z' as timestamp,
          entryEnd: '2022-06-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-20T07:00:00Z' as timestamp,
          entryEnd: '2022-06-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-21T07:00:00Z' as timestamp,
          entryEnd: '2022-06-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-22T07:00:00Z' as timestamp,
          entryEnd: '2022-06-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-23T07:00:00Z' as timestamp,
          entryEnd: '2022-06-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-24T07:00:00Z' as timestamp,
          entryEnd: '2022-06-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-25T07:00:00Z' as timestamp,
          entryEnd: '2022-06-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-26T07:00:00Z' as timestamp,
          entryEnd: '2022-06-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-27T07:00:00Z' as timestamp,
          entryEnd: '2022-06-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-28T07:00:00Z' as timestamp,
          entryEnd: '2022-06-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-29T07:00:00Z' as timestamp,
          entryEnd: '2022-06-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-06-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-01T07:00:00Z' as timestamp,
          entryEnd: '2022-07-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-02T07:00:00Z' as timestamp,
          entryEnd: '2022-07-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-03T07:00:00Z' as timestamp,
          entryEnd: '2022-07-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-04T07:00:00Z' as timestamp,
          entryEnd: '2022-07-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-05T07:00:00Z' as timestamp,
          entryEnd: '2022-07-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-06T07:00:00Z' as timestamp,
          entryEnd: '2022-07-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-07T07:00:00Z' as timestamp,
          entryEnd: '2022-07-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-08T07:00:00Z' as timestamp,
          entryEnd: '2022-07-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-09T07:00:00Z' as timestamp,
          entryEnd: '2022-07-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-10T07:00:00Z' as timestamp,
          entryEnd: '2022-07-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-11T07:00:00Z' as timestamp,
          entryEnd: '2022-07-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-12T07:00:00Z' as timestamp,
          entryEnd: '2022-07-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-13T07:00:00Z' as timestamp,
          entryEnd: '2022-07-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-14T07:00:00Z' as timestamp,
          entryEnd: '2022-07-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-15T07:00:00Z' as timestamp,
          entryEnd: '2022-07-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-16T07:00:00Z' as timestamp,
          entryEnd: '2022-07-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-17T07:00:00Z' as timestamp,
          entryEnd: '2022-07-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-18T07:00:00Z' as timestamp,
          entryEnd: '2022-07-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-19T07:00:00Z' as timestamp,
          entryEnd: '2022-07-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-20T07:00:00Z' as timestamp,
          entryEnd: '2022-07-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-21T07:00:00Z' as timestamp,
          entryEnd: '2022-07-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-22T07:00:00Z' as timestamp,
          entryEnd: '2022-07-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-23T07:00:00Z' as timestamp,
          entryEnd: '2022-07-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-24T07:00:00Z' as timestamp,
          entryEnd: '2022-07-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-25T07:00:00Z' as timestamp,
          entryEnd: '2022-07-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-26T07:00:00Z' as timestamp,
          entryEnd: '2022-07-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(0),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-27T07:00:00Z' as timestamp,
          entryEnd: '2022-07-28T07:00:00Z' as timestamp,
          count: int64.fromNumber(2),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-28T07:00:00Z' as timestamp,
          entryEnd: '2022-07-29T07:00:00Z' as timestamp,
          count: int64.fromNumber(92),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(80),
                int64.fromNumber(21),
                int64.fromNumber(1),
                int64.fromNumber(6),
                int64.fromNumber(30),
                int64.fromNumber(26),
                int64.fromNumber(26),
                int64.fromNumber(22),
                int64.fromNumber(14),
                int64.fromNumber(1),
                int64.fromNumber(4),
                int64.fromNumber(13),
                int64.fromNumber(15),
                int64.fromNumber(15),
                int64.fromNumber(13),
                int64.fromNumber(11),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(17),
                int64.fromNumber(13),
                int64.fromNumber(17),
                int64.fromNumber(14),
                int64.fromNumber(10),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(15),
                int64.fromNumber(11),
                int64.fromNumber(12),
                int64.fromNumber(13),
                int64.fromNumber(10),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(80),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(21),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(30),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(17),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(15),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-29T07:00:00Z' as timestamp,
          entryEnd: '2022-07-30T07:00:00Z' as timestamp,
          count: int64.fromNumber(47),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(41),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(9),
                int64.fromNumber(9),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(6),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(4),
                int64.fromNumber(1),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(4),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(41),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-30T07:00:00Z' as timestamp,
          entryEnd: '2022-07-31T07:00:00Z' as timestamp,
          count: int64.fromNumber(6),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-07-31T07:00:00Z' as timestamp,
          entryEnd: '2022-08-01T07:00:00Z' as timestamp,
          count: int64.fromNumber(13),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(11),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-01T07:00:00Z' as timestamp,
          entryEnd: '2022-08-02T07:00:00Z' as timestamp,
          count: int64.fromNumber(71),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(61),
                int64.fromNumber(14),
                int64.fromNumber(12),
                int64.fromNumber(13),
                int64.fromNumber(7),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(12),
                int64.fromNumber(11),
                int64.fromNumber(10),
                int64.fromNumber(11),
                int64.fromNumber(9),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(6),
                int64.fromNumber(9),
                int64.fromNumber(8),
                int64.fromNumber(7),
                int64.fromNumber(6),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(8),
                int64.fromNumber(7),
                int64.fromNumber(12),
                int64.fromNumber(9),
                int64.fromNumber(5),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(61),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(13),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(11),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-02T07:00:00Z' as timestamp,
          entryEnd: '2022-08-03T07:00:00Z' as timestamp,
          count: int64.fromNumber(63),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(55),
                int64.fromNumber(5),
                int64.fromNumber(9),
                int64.fromNumber(5),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(8),
                int64.fromNumber(10),
                int64.fromNumber(7),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(5),
                int64.fromNumber(5),
                int64.fromNumber(7),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(7),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(4),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(55),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-03T07:00:00Z' as timestamp,
          entryEnd: '2022-08-04T07:00:00Z' as timestamp,
          count: int64.fromNumber(54),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(46),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(6),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(8),
                int64.fromNumber(7),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(6),
                int64.fromNumber(4),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(46),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-04T07:00:00Z' as timestamp,
          entryEnd: '2022-08-05T07:00:00Z' as timestamp,
          count: int64.fromNumber(51),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(40),
                int64.fromNumber(6),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(5),
                int64.fromNumber(4),
                int64.fromNumber(7),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(40),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-05T07:00:00Z' as timestamp,
          entryEnd: '2022-08-06T07:00:00Z' as timestamp,
          count: int64.fromNumber(31),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(29),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(29),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-06T07:00:00Z' as timestamp,
          entryEnd: '2022-08-07T07:00:00Z' as timestamp,
          count: int64.fromNumber(6),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-07T07:00:00Z' as timestamp,
          entryEnd: '2022-08-08T07:00:00Z' as timestamp,
          count: int64.fromNumber(13),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(12),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-08T07:00:00Z' as timestamp,
          entryEnd: '2022-08-09T07:00:00Z' as timestamp,
          count: int64.fromNumber(58),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(48),
                int64.fromNumber(10),
                int64.fromNumber(7),
                int64.fromNumber(9),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(7),
                int64.fromNumber(7),
                int64.fromNumber(10),
                int64.fromNumber(9),
                int64.fromNumber(7),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(6),
                int64.fromNumber(6),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(7),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(48),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-09T07:00:00Z' as timestamp,
          entryEnd: '2022-08-10T07:00:00Z' as timestamp,
          count: int64.fromNumber(43),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(37),
                int64.fromNumber(12),
                int64.fromNumber(9),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(7),
                int64.fromNumber(4),
                int64.fromNumber(7),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(12),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(9),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-10T07:00:00Z' as timestamp,
          entryEnd: '2022-08-11T07:00:00Z' as timestamp,
          count: int64.fromNumber(48),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(34),
                int64.fromNumber(14),
                int64.fromNumber(6),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(6),
                int64.fromNumber(7),
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(5),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(4),
                int64.fromNumber(3),
                int64.fromNumber(4),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(34),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(14),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-11T07:00:00Z' as timestamp,
          entryEnd: '2022-08-12T07:00:00Z' as timestamp,
          count: int64.fromNumber(33),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(26),
                int64.fromNumber(5),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(26),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-12T07:00:00Z' as timestamp,
          entryEnd: '2022-08-13T07:00:00Z' as timestamp,
          count: int64.fromNumber(15),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(10),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(10),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-13T07:00:00Z' as timestamp,
          entryEnd: '2022-08-14T07:00:00Z' as timestamp,
          count: int64.fromNumber(2),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-14T07:00:00Z' as timestamp,
          entryEnd: '2022-08-15T07:00:00Z' as timestamp,
          count: int64.fromNumber(7),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(5),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-15T07:00:00Z' as timestamp,
          entryEnd: '2022-08-16T07:00:00Z' as timestamp,
          count: int64.fromNumber(32),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(27),
                int64.fromNumber(8),
                int64.fromNumber(4),
                int64.fromNumber(1),
                int64.fromNumber(5),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(7),
                int64.fromNumber(5),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(4),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(27),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(5),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-16T07:00:00Z' as timestamp,
          entryEnd: '2022-08-17T07:00:00Z' as timestamp,
          count: int64.fromNumber(29),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(23),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(4),
                int64.fromNumber(2),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-17T07:00:00Z' as timestamp,
          entryEnd: '2022-08-18T07:00:00Z' as timestamp,
          count: int64.fromNumber(49),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(37),
                int64.fromNumber(7),
                int64.fromNumber(4),
                int64.fromNumber(0),
                int64.fromNumber(0),
                int64.fromNumber(3),
                int64.fromNumber(2),
                int64.fromNumber(1),
                int64.fromNumber(3),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(37),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(7),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-18T07:00:00Z' as timestamp,
          entryEnd: '2022-08-19T07:00:00Z' as timestamp,
          count: int64.fromNumber(26),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(22),
                int64.fromNumber(3),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(2),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(22),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-19T07:00:00Z' as timestamp,
          entryEnd: '2022-08-20T07:00:00Z' as timestamp,
          count: int64.fromNumber(23),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(20),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(2),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(3),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(20),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(8),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(6),
                int64.fromNumber(1),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(1),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(7),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(6),
                int64.fromNumber(3),
                int64.fromNumber(0),
                int64.fromNumber(1),
                int64.fromNumber(0),
                int64.fromNumber(0),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(6),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(0),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(39),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(32),
                int64.fromNumber(8),
                int64.fromNumber(4),
                int64.fromNumber(4),
                int64.fromNumber(2),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(32),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(8),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(27),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(19),
                int64.fromNumber(2),
                int64.fromNumber(4),
                int64.fromNumber(3),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(19),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(28),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(23), int64.fromNumber(4), int64.fromNumber(4)],
              eventCounts: [
                {
                  count: int64.fromNumber(23),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(30),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(24), int64.fromNumber(4)],
              eventCounts: [
                {
                  count: int64.fromNumber(24),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(4),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(22),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(18)],
              eventCounts: [
                {
                  count: int64.fromNumber(18),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [
        {
          groupId: 'Germany',
          fallback: false,
        },
      ],
      id: '259d1e7e-8baa-498c-8230-19b75a463fdd',
    },
  ],
  numGroups: int64.fromNumber(177),
};

export const mockRetentionMetricDetail: RetentionMetricDetail = {
  retentionMetric: {
    retentionMetric: {
      id: 'my-retention-metric',
      name: 'My retention metric',
      description: 'My retention metric',
      retentionMetric: {
        onOrAfter: true,
        multipleEntries: false,
        entry: {
          primary: {
            click: {
              any: null,
            },
          },
          deps: [],
        },
        returns: [],
        constraints: {
          inSameSession: true,
          timeRange: {
            startTime: '2022-01-01T00:00:00Z',
            endTime: '2022-02-01T00:00:00Z',
          },
          completeSessions: true,
        },
        timeInterval: TimeInterval.TIME_INTERVAL_HOUR,
      },
      retentionSettings: {
        dimensionSettings: {
          dimension: null,
          dimensions: [],
          sortOrder: SortOrder.SORT_ORDER_ASC,
          sortByDefault: false,
          sortType: SortType.SORT_TYPE_INVALID,
          limit: 10,
          computeTopLevel: true,
          computeNumGroups: false,
          allowAllPartialResults: true,
          noFallback: true,
        },
        segment: [],
        timeRange: {
          startTime: '2022-01-01T00:00:00Z',
          endTime: '2022-02-01T00:00:00Z',
        },
        timeInterval: TimeInterval.TIME_INTERVAL_HOUR,
        returnWindow: 10,
        timeRangeComparison: null,
      },
    },
    metadata: {
      lastUpdated: '2022-01-01T00:00:00Z' as timestamp,
      lastUpdatedBy: 'trevorhutto@fullstory.com',
      created: '2022-01-01T00:00:00Z' as timestamp,
      createdBy: 'trevorhutto@fullstory.com',
      archived: false,
      visibility: Visibility.PUBLIC,
      version: int64.fromNumber(1),
      sequentialVersion: int64.fromNumber(1),
    },
  },
  starred: false,
  lastViewed: '2022-01-01T00:00:00Z' as timestamp,
};
